// Translations for the 23 treatment pages.
// Shape: { "/slug": { title, eyebrow, lead, cta, heroAlt, stats, candidate,
//   techniques, journey, risks, faq, ctaBand, disclaimer, seoTitle, seoDesc } }
export default {
  "/abdominoplasty": {
    title: "Addominoplastica a Istanbul",
    eyebrow: "Rimodellamento corporeo",
    lead:
      "L'addominoplastica rimuove la pelle e il grasso in eccesso che dieta e attività fisica non riescono a modificare, e tende la parete addominale sottostante. È un intervento di rimodellamento corporeo, non un'operazione per perdere peso.",
    cta: "Prenota una valutazione gratuita",
    heroAlt: "Consultazione per addominoplastica presso Platinya Clinic",
    stats: [
      { value: "2–4 h", label: "Durata dell'intervento" },
      { value: "1–2 notti", label: "Degenza in clinica" },
      { value: "2–3 settimane", label: "Ritorno al lavoro d'ufficio" },
    ],
    candidate: {
      heading: "Chi è un buon candidato",
      intro:
        "L'intervento dà i risultati migliori su chi ha un peso stabile da almeno sei mesi, è in buone condizioni generali di salute e il cui problema riguarda la forma più che i chilogrammi.",
      items: [
        "Pelle rilassata o muscoli addominali separati dopo la gravidanza",
        "Pelle cadente dopo una perdita di peso importante, quando il peso si è stabilizzato",
        "Un accumulo ostinato nella parte bassa dell'addome che non cambia con l'allenamento",
        "Smagliature o una cicatrice da cesareo che ricadono in una zona di pelle che verrà comunque rimossa",
      ],
      note:
        "L'addominoplastica non è un trattamento dell'obesità e non sostituisce la perdita di peso. Se prevedi una gravidanza o un'ulteriore perdita di peso importante, di solito è meglio attendere: il risultato è pensato per durare.",
    },
    techniques: {
      heading: "Cosa si può fare e come si sceglie",
      intro:
        "La tecnica si decide in consulenza, partendo dalla pelle, dallo strato muscolare e dal tipo di cicatrice — mai da una fotografia.",
      items: [
        {
          name: "Addominoplastica completa",
          text:
            "Un'incisione orizzontale in basso sull'addome, la pelle sollevata fino alle costole, i muscoli addominali tensionati sulla linea mediana e la pelle in eccesso rimossa. L'ombelico viene riposizionato. Indicata quando la lassità interessa sia sopra sia sotto l'ombelico.",
        },
        {
          name: "Mini addominoplastica",
          text:
            "Incisione più breve e recupero più rapido, per una lassità limitata alla parte bassa dell'addome. L'ombelico di norma resta in sede; il tensionamento muscolare è limitato.",
        },
        {
          name: "Addominoplastica estesa",
          text:
            "Come un'addominoplastica completa, ma prolungata sui fianchi, per la pelle che cade anche ai lati. Spesso associata a liposuzione della vita.",
        },
        {
          name: "Riparazione muscolare (plicatura)",
          text:
            "Quando i muscoli retti si sono separati — evenienza frequente dopo la gravidanza — vengono suturati verso la linea mediana. È questo che cambia il profilo dell'addome, non solo la pelle.",
        },
      ],
    },
    journey: {
      heading: "Dalla consulenza al recupero",
      steps: [
        {
          name: "Consulenza e pianificazione",
          text:
            "Fotografie, anamnesi e un confronto franco su cicatrici, tempi di recupero e su ciò che l'intervento può e non può fare. Prima di fissare una data si eseguono esami del sangue e, se necessario, un'ecografia o un parere cardiologico.",
        },
        {
          name: "Preparazione",
          text:
            "Si smette di fumare almeno tre o quattro settimane prima dell'intervento, gli anticoagulanti e alcuni integratori vengono sospesi circa dieci giorni prima e si resta a digiuno per sei-otto ore. Organizza chi ti venga a prendere e ti aiuti a casa la prima settimana.",
        },
        {
          name: "L'intervento",
          text:
            "In anestesia generale, di solito due-quattro ore. Spesso si lascia un drenaggio per alcuni giorni. La maggior parte dei pazienti resta una o due notti in clinica, con la guaina compressiva applicata prima della dimissione.",
        },
        {
          name: "Le prime due settimane",
          text:
            "Si cammina dal primo giorno, per brevi distanze, con la schiena dritta. La guaina si indossa giorno e notte. Il gonfiore raggiunge il picco intorno al terzo-quinto giorno e poi si riduce; la prima doccia e la rimozione del drenaggio si programmano in clinica.",
        },
        {
          name: "Dalla terza alla sesta settimana",
          text:
            "Il lavoro d'ufficio è di solito possibile dopo due-tre settimane. Palestra, nuoto e sollevamento pesi si riprendono intorno alla sesta settimana, quando il chirurgo verifica che i tessuti siano guariti.",
        },
        {
          name: "La cicatrice, nell'arco di un anno",
          text:
            "Nei primi mesi la cicatrice è rossa e consistente, poi sbiadisce e si appiattisce — un processo che continua per dodici-diciotto mesi. È collocata in basso, all'interno della linea degli indumenti intimi.",
        },
      ],
    },
    risks: {
      heading: "Cosa può andare storto",
      intro: "Ogni intervento comporta dei rischi, e vanno ascoltati prima di decidere, non dopo.",
      items: [
        "Sieroma — una raccolta di liquido sotto la pelle; è il problema più frequente e di solito si drena in clinica",
        "Infezione o guarigione ritardata della ferita, più probabili nei fumatori",
        "Cicatrici larghe o rilevate, che possono essere corrette in seguito ma non cancellate",
        "Intorpidimento intorno alla cicatrice e all'ombelico, che di norma migliora nel corso dei mesi",
        "Asimmetria o un contorno che richiede una piccola revisione (circa un paziente su dieci)",
        "Sanguinamento, ematomi e, raramente, trombosi — prevenute con la mobilizzazione precoce e la compressione",
      ],
      note:
        "In consulenza parlaci del fumo, del diabete, degli anticoagulanti e di eventuali interventi addominali precedenti. Ognuno di questi fattori cambia il piano, e nasconderne uno è il modo più rapido per avere un recupero complicato.",
    },
    faq: {
      heading: "Domande che i pazienti pongono",
      items: [
        {
          q: "Fa male?",
          a:
            "I primi due o tre giorni sono più fastidiosi che dolorosi — una sensazione di tensione e di livido su tutto l'addome. Si controlla con normali analgesici e la maggior parte dei pazienti cammina e mangia regolarmente prima della dimissione.",
        },
        {
          q: "La cicatrice si vedrà?",
          a:
            "Una cicatrice c'è ed è permanente. È collocata in basso, lungo la linea degli indumenti intimi, e sbiadisce nell'arco di dodici-diciotto mesi. Come guarisce dipende dalla pelle, dal non fumare e dal rispetto delle indicazioni per la medicazione.",
        },
        {
          q: "Posso avere figli dopo?",
          a:
            "Di solito sì, ma durante la gravidanza l'addome si distenderà di nuovo e una parte del risultato può andare persa. Per questo molti chirurghi consigliano di completare il progetto familiare prima.",
        },
        {
          q: "Si può associare alla liposuzione?",
          a:
            "Spesso sì: la liposuzione dei fianchi o della vita è comunemente aggiunta per armonizzare il passaggio. Se sia sicura nel tuo caso dipende dalla zona coinvolta e dalla durata dell'intervento, ed è una decisione chirurgica.",
        },
        {
          q: "Quanto peso perderò?",
          a:
            "Un po', ma non è questo il punto. L'intervento cambia la forma dell'addome. Se il tuo obiettivo è perdere peso, il punto di partenza corretto è una valutazione bariatrica, non un'addominoplastica.",
        },
        {
          q: "Quanto costa?",
          a:
            "Il prezzo dipende dalla tecnica, dalla clinica, dalla durata della degenza e dalla necessità di riparare i muscoli, perciò si quantifica dopo la valutazione e non prima. Il preventivo comprende intervento, anestesia, degenza, guaine e visite di controllo.",
        },
      ],
    },
    ctaBand: {
      heading: "Invia le tue fotografie per un primo parere",
      text:
        "Un chirurgo le esamina e un coordinatore ti risponde con un piano, una data e un preventivo scritto — senza impegno e senza pressione per prenotare.",
      button: "Parla con un coordinatore",
    },
    disclaimer:
      "Questa pagina contiene informazioni generali, non consigli medici. L'idoneità, la tecnica e i rischi si valutano in una consulenza con un chirurgo.",
    seoTitle: "Addominoplastica a Istanbul | Platinya Clinic",
    seoDesc:
      "Addominoplastica a Istanbul: pelle in eccesso rimossa e parete addominale tensionata. Una o due notti in clinica, ritorno al lavoro in 2-3 settimane.",
  },

  "/hair-transplant": {
    title: "Trapianto di capelli a Istanbul (FUE)",
    eyebrow: "Ripristino dei capelli",
    lead:
      "I follicoli vengono prelevati dalla parte posteriore del cuoio capelluto — dove resistono alla caduta — e impiantati nelle zone diradate. Il risultato è il tuo capello, che ricresce dove non cresceva più.",
    cta: "Prenota una valutazione gratuita",
    heroAlt: "Valutazione per trapianto di capelli presso Platinya Clinic",
    stats: [
      { value: "6–9 h", label: "Durata della procedura" },
      { value: "1 giorno", label: "In clinica" },
      { value: "12–18 mesi", label: "Risultato finale" },
    ],
    candidate: {
      heading: "Chi è un buon candidato",
      intro:
        "Il fattore limitante non è quanto capello manca, ma quanto capello donatore è disponibile nella parte posteriore e ai lati, e quanto è stata stabile la perdita.",
      items: [
        "Perdita stabile da circa un anno, non in caduta di settimana in settimana",
        "Densità sufficiente nell'area donatrice per il numero di innesti che l'area calva richiede",
        "Attaccatura che arretra, perdita alle tempie o diradamento della corona",
        "Aspettative realistiche: la densità migliora, ma un'area calva non torna mai alla densità dell'adolescenza",
      ],
      note:
        "Se la perdita è ancora attiva, curarla prima — sul piano medico — protegge il risultato. Il trapianto sposta i capelli; non ferma il diradamento di quelli che hai ancora.",
    },
    techniques: {
      heading: "Come si prelevano e si impiantano i capelli",
      intro:
        "Il metodo si sceglie in base alla densità donatrice, all'estensione dell'area e all'acconciatura che vuoi mantenere.",
      items: [
        {
          name: "FUE — estrazione di unità follicolari",
          text:
            "I singoli follicoli vengono prelevati con un punch e reimpiantati. Non si rimuove alcuna striscia di pelle, quindi non c'è cicatrice lineare; il compromesso è che l'area donatrice viene rasata e la guarigione richiede qualche giorno.",
        },
        {
          name: "DHI — impianto diretto",
          text:
            "I follicoli sono posizionati con una penna monouso, che consente un controllo preciso di angolo e profondità sull'attaccatura. È più lento, quindi si impiantano meno innesti per seduta.",
        },
        {
          name: "Disegno dell'attaccatura",
          text:
            "La linea si disegna insieme a te, seduto e in piedi, prima di qualsiasi taglio: deve reggere l'invecchiamento e l'ulteriore perdita, per questo si colloca in modo prudente e non troppo bassa.",
        },
      ],
    },
    journey: {
      heading: "Dalla consulenza al risultato finale",
      steps: [
        {
          name: "Valutazione",
          text:
            "Si misura la densità donatrice, si disegna l'attaccatura e si prescrivono gli esami del sangue. Si scattano fotografie da cinque angolazioni per il confronto successivo.",
        },
        {
          name: "Il giorno dell'intervento",
          text:
            "Anestesia locale con sedazione leggera; resti sveglio e puoi mangiare. La seduta è lunga — da sei a nove ore — e viene interrotta da brevi pause.",
        },
        {
          name: "I primi dieci giorni",
          text:
            "Si formano piccole croste che dal secondo giorno si lavano via delicatamente. Il gonfiore sulla fronte è frequente e si risolve entro una settimana.",
        },
        {
          name: "Dalla terza alla dodicesima settimana",
          text:
            "La maggior parte dei capelli trapiantati cade — è previsto e non significa fallimento. La nuova crescita inizia intorno al terzo mese.",
        },
        {
          name: "Dal dodicesimo mese in poi",
          text:
            "Densità e spessore continuano a migliorare fino a 12–18 mesi. Una seconda seduta per aggiungere densità, se desiderata, si programma non prima di dodici mesi.",
        },
      ],
    },
    risks: {
      heading: "Cosa può andare storto",
      intro:
        "Un trapianto è un vero intervento, con limiti reali. Questi sono quelli da conoscere prima di prenotare.",
      items: [
        "Gonfiore, arrossamento e croste nella prima settimana, e intorpidimento temporaneo del cuoio capelluto",
        "La sopravvivenza dei follicoli non è mai del 100%: una parte degli innesti non ricresce",
        "Copertura disomogenea o rada se il numero di innesti previsto non è sostenuto dalla disponibilità donatrice",
        "Follicolite — piccole pustole infette nell'area ricevente, di solito trattabili",
        "Un'attaccatura innaturale se il disegno è troppo basso o troppo denso per l'area donatrice",
      ],
      note:
        "Scegli il piano in base al numero di innesti e alla qualità della zona donatrice, non al prezzo più basso: una seduta economica che sfrutta troppo la zona donatrice non si può annullare.",
    },
    faq: {
      heading: "Domande che i pazienti pongono",
      items: [
        {
          q: "È doloroso?",
          a:
            "Le punture pizzicano per pochi secondi; dopo, il cuoio capelluto è insensibile e la procedura è più noiosa che dolorosa. La prima notte è di indolenzimento e si risolve con normali analgesici.",
        },
        {
          q: "Resterà una cicatrice?",
          a:
            "La FUE lascia piccoli segni circolari nella zona donatrice, che con una lunghezza normale dei capelli diventano quasi invisibili. La tecnica a striscia lascia una linea sottile sulla parte posteriore del cuoio capelluto.",
        },
        {
          q: "Quando posso tornare al lavoro?",
          a:
            "Al lavoro d'ufficio dopo due o tre giorni, quando il gonfiore si è ridotto. Attività fisica intensa, sauna e nuoto richiedono circa due settimane.",
        },
        {
          q: "I nuovi capelli durano?",
          a:
            "I follicoli trapiantati mantengono il comportamento della zona donatrice e in genere sono permanenti. I capelli circostanti possono comunque diradarsi, per questo spesso si prosegue la terapia medica.",
        },
      ],
    },
    ctaBand: {
      heading: "Invia le tue fotografie per un primo parere",
      text:
        "Fotografie dell'attaccatura, della corona e della zona donatrice bastano per dire se un trapianto è sensato, all'incirca quanti innesti servono e quanto costerebbe.",
      button: "Invia le tue foto",
    },
    disclaimer:
      "Informazioni generali, non consigli medici. L'idoneità si può valutare solo dopo aver esaminato il cuoio capelluto e l'anamnesi; i risultati variano da paziente a paziente.",
    seoTitle: "Trapianto di capelli a Istanbul (FUE) | Platinya",
    seoDesc:
      "Trapianto di capelli FUE a Istanbul: i tuoi follicoli spostati nelle zone diradate. Una giornata in clinica, risultato finale a 12-18 mesi.",
  },

  "/sapphire-hair-transplant": {
    title: "Trapianto di capelli FUE sapphire a Istanbul",
    eyebrow: "Ripristino dei capelli",
    lead:
      "Il FUE sapphire è la stessa estrazione di unità follicolari del FUE standard, ma i canali per gli innesti vengono aperti con lame di zaffiro invece che d'acciaio. La differenza sta nelle incisioni, non nei follicoli.",
    cta: "Prenota una valutazione gratuita",
    heroAlt: "Pianificazione del trapianto FUE sapphire presso Platinya Clinic",
    stats: [
      { value: "6–8 h", label: "Durata della procedura" },
      { value: "1 giorno", label: "In clinica" },
      { value: "10–14 giorni", label: "Scompaiono le croste" },
    ],
    candidate: {
      heading: "Chi è un buon candidato",
      intro:
        "Lo zaffiro è una tecnica, non un criterio di idoneità: valgono le stesse regole di qualsiasi trapianto — perdita stabile e capelli donatori sufficienti.",
      items: [
        "Perdita stabile con una zona donatrice sana nella parte posteriore e ai lati",
        "Diradamento dell'attaccatura, delle tempie o della corona che la sola terapia medica non ha risolto",
        "Pelle senza infezioni attive, eczema o psoriasi nell'area ricevente",
        "Consapevolezza che la lama cambia la guarigione, non il numero di innesti che la zona donatrice può dare",
      ],
      note:
        "Le cliniche che pubblicizzano lo zaffiro come garanzia di capelli più densi sopravvalutano lo strumento. L'attecchimento dipende da come vengono trattati i follicoli, non solo dalla lama.",
    },
    techniques: {
      heading: "Cosa cambia la lama di zaffiro",
      intro:
        "La stessa operazione, con un filo di taglio diverso e un diverso equilibrio di vantaggi e limiti.",
      items: [
        {
          name: "Canali più sottili",
          text:
            "Le lame di zaffiro incidono una fessura più fine dell'acciaio, così il tessuto viene separato anziché lacerato. Aperture più piccole significano meno croste e, nella maggior parte dei pazienti, una guarigione più rapida.",
        },
        {
          name: "Innesto più aderente",
          text:
            "Un innesto che aderisce bene al suo canale ha meno probabilità di muoversi nei primi giorni. Questo conta soprattutto sull'attaccatura, dove direzione e angolo sono visibili.",
        },
        {
          name: "Cosa non cambia",
          text:
            "Non aumenta il numero di innesti che la zona donatrice può offrire e non sostituisce il piano: densità, disegno dell'attaccatura e gestione dei follicoli da parte dell'équipe decidono il risultato.",
        },
      ],
    },
    journey: {
      heading: "La giornata, ora per ora",
      steps: [
        {
          name: "Disegno e rasatura",
          text:
            "L'attaccatura si disegna e si concorda prima di qualsiasi taglio. La zona donatrice viene accorciata; l'area ricevente viene rasata nella maggior parte dei casi.",
        },
        {
          name: "Anestesia",
          text: "Iniezioni di anestetico locale con sedazione leggera. Il fastidio è limitato ai primi minuti.",
        },
        {
          name: "Estrazione e canali",
          text:
            "I follicoli vengono estratti e mantenuti al fresco in soluzione, poi si aprono i canali di zaffiro con l'angolo richiesto dall'attaccatura.",
        },
        {
          name: "Impianto",
          text:
            "Gli innesti vengono posizionati uno a uno. Nelle sedute più lunghe l'équipe lavora a turni per mantenere una gestione costante.",
        },
        {
          name: "Guarigione",
          text:
            "Le micro-croste cadono in 10–14 giorni. I capelli trapiantati cadono dalla terza settimana, poi ricrescono dal terzo mese in avanti.",
        },
      ],
    },
    risks: {
      heading: "Cosa può andare storto",
      intro: "Ogni trapianto comporta gli stessi rischi fondamentali, qualunque sia la lama.",
      items: [
        "Gonfiore, indolenzimento e intorpidimento temporaneo nelle aree donatrice e ricevente",
        "Croste e arrossamento che durano più del previsto nelle pelli sensibili",
        "Alcuni innesti non attecchiscono, per questo a volte serve una seconda seduta",
        "Follicolite o piccole cisti intorno ai nuovi innesti nelle prime settimane",
        "Un'attaccatura troppo dritta o troppo densa se il disegno non è stato prudente",
      ],
      note:
        "Chiedi quanti innesti sono previsti, chi apre i canali e chi impianta: le risposte dicono del risultato più della parola zaffiro.",
    },
    faq: {
      heading: "Domande che i pazienti pongono",
      items: [
        {
          q: "Lo zaffiro è meglio del FUE in acciaio?",
          a:
            "Guarisce un po' più in fretta e produce meno croste. Le prove indipendenti che faccia ricrescere più capelli sono deboli; conta di più la gestione degli innesti da parte del chirurgo.",
        },
        {
          q: "Fa più male?",
          a: "No. L'anestesia è la stessa; la lama viene usata su pelle già insensibile.",
        },
        {
          q: "Quando scompaiono le croste?",
          a: "Di solito entro 10–14 giorni, con un lavaggio delicato dal secondo giorno.",
        },
        {
          q: "Basta una seduta?",
          a:
            "Per molti pazienti sì. Grandi aree calve o una bassa densità donatrice possono richiedere una seconda seduta dopo dodici mesi per raggiungere la densità prevista.",
        },
      ],
    },
    ctaBand: {
      heading: "Invia le tue fotografie per un primo parere",
      text:
        "Ti diremo con onestà se nel tuo caso il FUE sapphire aggiunge qualcosa e quale sarebbe il numero di innesti.",
      button: "Invia le tue foto",
    },
    disclaimer:
      "Informazioni generali, non consigli medici. L'idoneità si decide dopo la visita; i risultati variano da paziente a paziente.",
    seoTitle: "Trapianto FUE sapphire a Istanbul | Platinya",
    seoDesc:
      "FUE sapphire a Istanbul: canali più sottili, meno croste e guarigione più rapida. Limiti della tecnica e numero di innesti spiegati con chiarezza.",
  },

  "/hair-implant-hybrid": {
    title: "Trapianto di capelli ibrido (FUE + FUT) a Istanbul",
    eyebrow: "Ripristino dei capelli",
    lead:
      "Una seduta ibrida utilizza entrambi i modi di prelevare i capelli — una sottile striscia dalla parte posteriore del cuoio capelluto e singole unità follicolari — in un'unica operazione, quando un solo metodo non basta a fornire il numero di innesti richiesto dall'area calva.",
    cta: "Prenota una valutazione gratuita",
    heroAlt: "Confronto delle tecniche di trapianto ibrido presso Platinya Clinic",
    stats: [
      { value: "1 seduta", label: "Due tecniche" },
      { value: "+30–50%", label: "Innesti rispetto al solo FUE" },
      { value: "12 mesi", label: "Per giudicare il risultato" },
    ],
    candidate: {
      heading: "A chi è destinato",
      intro:
        "L'ibrido risolve un problema di disponibilità con due strumenti: esiste per grandi aree calve e per una zona donatrice non abbastanza densa da dare tutto con la sola estrazione.",
      items: [
        "Perdita avanzata — Norwood da 5 a 6 — in cui una singola seduta di FUE lascerebbe la corona rada",
        "Buona densità nella zona della striscia ma unità follicolari limitate per l'estrazione",
        "Una precedente seduta di FUE che ha consumato i siti donatori accessibili",
        "Disponibilità ad accettare una sottile cicatrice lineare in cambio di un numero di innesti molto maggiore",
      ],
      note:
        "Più innesti non significa automaticamente meglio. L'ibrido ha senso quando il piano richiede davvero quei numeri in più; per aree più piccole una sola tecnica è più semplice e guarisce più in fretta.",
    },
    techniques: {
      heading: "Come lavorano insieme le due parti",
      intro:
        "Prima si preleva la striscia, poi l'estrazione completa il resto del piano — un'unica anestesia, un solo giorno.",
      items: [
        {
          name: "La striscia (FUT)",
          text:
            "Si rimuove una stretta ellisse di cuoio capelluto dalla parte posteriore, si chiude a strati e si disseziona in singoli innesti al microscopio. È la fonte più densa di innesti per centimetro quadrato.",
        },
        {
          name: "L'estrazione (FUE)",
          text:
            "I follicoli vengono poi prelevati singolarmente ai lati, aggiungendo innesti senza un'altra linea di cicatrice — e, cosa importante, senza indebolire la chiusura della striscia.",
        },
        {
          name: "Perché non fare semplicemente più FUE",
          text:
            "Perché sfruttare eccessivamente una zona donatrice la lascia disomogenea e chiude la porta a qualsiasi seduta futura. L'ibrido distribuisce il carico su due zone donatrici.",
        },
      ],
    },
    journey: {
      heading: "Dalla pianificazione al risultato finale",
      steps: [
        {
          name: "Calcolo degli innesti",
          text:
            "La densità donatrice nella zona della striscia e in quella dell'estrazione si misura separatamente, e si somma il numero di innesti che ciascuna può dare. Quel totale definisce il piano.",
        },
        {
          name: "Il giorno dell'intervento",
          text:
            "Il prelievo della striscia richiede circa un'ora; l'équipe disseziona mentre l'estrazione prosegue. Per una seduta ampia si considerino da otto a dieci ore in totale.",
        },
        {
          name: "Le prime due settimane",
          text:
            "La linea della striscia viene chiusa con punti o clip, rimossi intorno al decimo-quattordicesimo giorno. Le croste nell'area ricevente si risolvono nello stesso periodo.",
        },
        {
          name: "Dal primo al terzo mese",
          text: "I capelli trapiantati cadono, poi inizia la ricrescita. La cicatrice lineare passa dal rosso al chiaro.",
        },
        {
          name: "Dal dodicesimo al diciottesimo mese",
          text:
            "Densità definitiva. Con una lunghezza normale dei capelli la cicatrice della striscia è di solito coperta dai capelli circostanti; con tagli molto corti si vede.",
        },
      ],
    },
    risks: {
      heading: "Cosa può andare storto",
      intro: "L'ibrido porta con sé, contemporaneamente, i rischi di entrambe le tecniche.",
      items: [
        "Una cicatrice lineare permanente sulla parte posteriore del cuoio capelluto, nascosta dai capelli a lunghezza normale",
        "Tensione o allargamento della cicatrice se la chiusura è in trazione o la guarigione è scarsa",
        "Intorpidimento temporaneo sopra la cicatrice, che può richiedere mesi per risolversi",
        "I rischi abituali di ogni trapianto: gonfiore, follicolite, perdita parziale di innesti",
        "Una seduta lunga — la stanchezza riguarda sia il paziente sia l'équipe, per questo la giornata è organizzata a tappe",
      ],
      note:
        "Chiedi chi chiude la striscia e quante sedute ibride la clinica esegue al mese. La chiusura è la parte che i pazienti giudicano anni dopo.",
    },
    faq: {
      heading: "Domande che i pazienti pongono",
      items: [
        {
          q: "Quanti innesti può dare un ibrido?",
          a:
            "Comunemente 4.000–6.000 in una seduta, per una zona donatrice adatta, contro circa 2.500–3.500 del solo FUE. Il dato esatto si misura, non si promette.",
        },
        {
          q: "La cicatrice si vedrà?",
          a:
            "Con una lunghezza normale dei capelli, di solito no. Con la testa rasata o un taglio molto corto si vede come una linea chiara, e questo va accettato prima di prenotare.",
        },
        {
          q: "È più doloroso del FUE?",
          a:
            "Le prime due notti sono più tese per via della chiusura. Dopo, le due zone si somigliano; l'area della striscia è spesso descritta come un indolenzimento da livido.",
        },
        {
          q: "Posso fare un FUE in seguito?",
          a:
            "Sì, se le zone di estrazione non sono state esaurite. È esattamente per questo che il piano distribuisce la zona donatrice su sedute future invece di consumarla tutta in una volta.",
        },
      ],
    },
    ctaBand: {
      heading: "Invia le tue fotografie per un primo parere",
      text:
        "Misureremo entrambe le zone donatrici e ti diremo se un ibrido aggiunge qualcosa rispetto a una sola tecnica.",
      button: "Invia le tue foto",
    },
    disclaimer:
      "Informazioni generali, non consigli medici. L'idoneità e il numero di innesti si decidono dopo la visita; i risultati variano.",
    seoTitle: "Trapianto ibrido FUE e FUT a Istanbul | Platinya",
    seoDesc:
      "Trapianto ibrido FUE e FUT a Istanbul: striscia e unità follicolari in un'unica seduta per aree calve estese. Due zone donatrici, un solo intervento.",
  },

  "/hair-transplant-for-women": {
    title: "Trapianto di capelli per donne a Istanbul",
    eyebrow: "Ripristino dei capelli",
    lead:
      "Nelle donne la perdita di capelli è di solito un diradamento diffuso più che una chiazza calva, e spesso ha una causa che si può curare. Il trapianto si considera dopo aver escluso queste cause, e funziona diversamente dall'intervento maschile.",
    cta: "Prenota una valutazione gratuita",
    heroAlt: "Consultazione per la perdita di capelli nelle donne presso Platinya Clinic",
    stats: [
      { value: "1 giorno", label: "In clinica" },
      { value: "Nessuna rasatura", label: "Nella maggior parte dei casi" },
      { value: "12 mesi", label: "Per giudicare la densità" },
    ],
    candidate: {
      heading: "A chi aiuta, e a chi no",
      intro:
        "Nelle donne la prima domanda non è quanti innesti, ma perché i capelli si stanno diradando. Gli esami del sangue vengono prima di qualsiasi piano chirurgico.",
      items: [
        "Diradamento che continua nonostante valori normali di ferro, tiroide, vitamina D e ormoni",
        "Diradamento localizzato sulla riga, sulle tempie o lungo l'attaccatura frontale",
        "Cicatrici da trazione, ustioni, interventi o alopecia stabile da un anno",
        "Perdita di sopracciglia o dell'attaccatura dopo una depilazione eccessiva o un trauma da trucco permanente",
      ],
      note:
        "La caduta diffusa su tutto il cuoio capelluto — effluvio telogeno — è di solito reversibile e non si tratta con la chirurgia. Si cercano prima carenza di ferro, patologie tiroidee, sindrome dell'ovaio policistico e caduta post-partum, perché trapiantare in una fase di caduta attiva spreca innesti.",
    },
    techniques: {
      heading: "Come cambia l'intervento femminile",
      intro:
        "Il principio è lo stesso, la pratica no: meno rasatura, meno innesti, più attenzione a come i capelli ricadono.",
      items: [
        {
          name: "Rasatura parziale o assente",
          text:
            "I follicoli possono essere prelevati da una fascia stretta che i capelli circostanti coprono, quindi la zona donatrice non deve essere rasata. È più lento, quindi le sedute sono più piccole.",
        },
        {
          name: "Densità, non copertura",
          text:
            "Nelle donne si tratta di aggiungere densità tra i capelli esistenti, non di ricostruire un'attaccatura. Gli innesti sono collocati tra i follicoli nativi con un angolo che segue la caduta naturale.",
        },
        {
          name: "In associazione alla terapia medica",
          text:
            "Minoxidil e, in alcuni casi, farmaci prescritti vengono di solito proseguiti prima e dopo l'intervento: il trapianto aggiunge densità, non arresta il processo di base.",
        },
      ],
    },
    journey: {
      heading: "Dalla prima consulenza",
      steps: [
        {
          name: "Prima le cause",
          text:
            "Esami del sangue, storia del tipo di caduta e tricoscopia. Se si trova una causa reversibile, la si tratta prima di riparlare di chirurgia.",
        },
        {
          name: "Pianificare la densità",
          text:
            "L'area viene mappata e il numero di innesti è volutamente contenuto: un impianto troppo fitto su un cuoio capelluto femminile diradato può danneggiare i capelli ancora presenti.",
        },
        {
          name: "Il giorno dell'intervento",
          text:
            "Anestesia locale; la seduta dura di solito quattro-sei ore. La maggior parte delle pazienti torna a casa lo stesso giorno.",
        },
        {
          name: "Il primo mese",
          text:
            "Gonfiore e indolenzimento si risolvono in pochi giorni. I capelli trapiantati cadono dalla terza settimana — è previsto.",
        },
        {
          name: "Dal sesto al dodicesimo mese",
          text:
            "La densità cresce gradualmente. Colore e consistenza si allineano ai capelli circostanti man mano che maturano.",
        },
      ],
    },
    risks: {
      heading: "Cosa può andare storto",
      intro: "I rischi sono quelli standard, con due che contano di più nelle donne.",
      items: [
        "Caduta da shock dei capelli intorno agli innesti nelle prime settimane — di solito temporanea, ma impressionante",
        "Un impianto troppo denso che danneggia i follicoli nativi di un cuoio capelluto diradato",
        "Risultato disomogeneo se la causa di fondo era ancora attiva durante l'intervento",
        "Follicolite, croste e intorpidimento temporaneo",
        "Una variazione visibile della consistenza dei capelli nell'area trapiantata in una minoranza di pazienti",
      ],
      note:
        "Una clinica che propone l'intervento senza chiedere di ferro, tiroide e ormoni salta la parte che decide se l'operazione valeva la pena.",
    },
    faq: {
      heading: "Domande che i pazienti pongono",
      items: [
        {
          q: "Dovrò rasarmi la testa?",
          a:
            "Di solito no. La maggior parte delle sedute femminili usa una fascia donatrice parzialmente rasata, che i capelli circostanti coprono, oppure nessuna rasatura con un'estrazione più lenta.",
        },
        {
          q: "Potrò portare i capelli come prima?",
          a:
            "Dopo circa dieci giorni sì, con delicatezza. Colore e permanente richiedono sei-otto settimane, e code strette o trecce vanno evitate per il primo mese.",
        },
        {
          q: "Basta una seduta?",
          a:
            "Per un diradamento diffuso si programmano spesso due sedute, a dodici mesi di distanza, perché aggiungere densità gradualmente protegge i capelli esistenti.",
        },
        {
          q: "E se la causa è ormonale?",
          a:
            "Allora la terapia ormonale è la base e la chirurgia è solo un'aggiunta. Operare mentre la perdita è attiva dà un risultato che si dirada intorno agli innesti.",
        },
      ],
    },
    ctaBand: {
      heading: "Invia le tue fotografie per un primo parere",
      text:
        "Fotografie della riga, dell'attaccatura e della zona donatrice, insieme agli ultimi esami del sangue, bastano per un primo parere, anche su se la chirurgia sia davvero la risposta giusta.",
      button: "Invia le tue foto",
    },
    disclaimer:
      "Informazioni generali, non consigli medici. La perdita di capelli nelle donne richiede una diagnosi prima di qualsiasi piano chirurgico; i risultati variano.",
    seoTitle: "Trapianto di capelli per donne a Istanbul | Platinya",
    seoDesc:
      "Trapianto di capelli per donne a Istanbul: densità tra i capelli esistenti, spesso senza rasatura. Cause da escludere prima e tempi di ricrescita.",
  },

  "/eyebrow-transplant": {
    title: "Trapianto di sopracciglia a Istanbul",
    eyebrow: "Ripristino dei capelli",
    lead:
      "Singoli capelli vengono prelevati dal cuoio capelluto e inseriti nel sopracciglio con l'angolo di crescita di ogni pelo, per ricostruire un sopracciglio che depilazione, cicatrici o predisposizione genetica hanno reso rado.",
    cta: "Prenota una valutazione gratuita",
    heroAlt: "Consultazione per trapianto di sopracciglia presso Platinya Clinic",
    stats: [
      { value: "3–4 h", label: "Durata della procedura" },
      { value: "200–400", label: "Innesti per sopracciglio" },
      { value: "6–9 mesi", label: "Forma definitiva" },
    ],
    candidate: {
      heading: "A chi è destinato",
      intro:
        "Le sopracciglia sono il trapianto più visibile del viso, quindi il primo compito è capire se la forma è ancora ricostruibile.",
      items: [
        "Diradamento da anni di depilazione eccessiva, quando i follicoli hanno smesso di recuperare",
        "Cicatrici da ustioni, tagli o rimozione di trucco permanente",
        "Sopracciglia naturalmente rade o asimmetriche, o perdita dopo chemioterapia non recuperata",
        "Pelle sana, senza eczema, psoriasi o infezioni attive nella zona delle sopracciglia",
      ],
      note:
        "Se il sopracciglio è rado per una patologia tiroidea o una carenza nutrizionale, si tratta prima quella. I capelli prelevati dal cuoio capelluto continuano a crescere come capelli e vanno quindi tagliati: è una manutenzione permanente, da capire prima di prenotare.",
    },
    techniques: {
      heading: "Come si esegue",
      intro:
        "Precisione più che volume: poche centinaia di capelli singoli, ciascuno inserito con il proprio angolo.",
      items: [
        {
          name: "Innesti di un solo capello",
          text:
            "Si utilizzano solo unità follicolari da uno o due capelli. Gli innesti multipli appaiono a ciuffi in un sopracciglio, perciò il sito donatore si sceglie per capelli fini e singoli — spesso dietro l'orecchio.",
        },
        {
          name: "Angolo e direzione",
          text:
            "I peli del sopracciglio crescono verso l'alto e verso l'esterno all'inizio e si appiattiscono verso la coda. Ogni innesto è collocato singolarmente per seguire questo schema, altrimenti il risultato appare innaturale.",
        },
        {
          name: "Densità in due tempi",
          text:
            "Un primo passaggio prudente protegge l'irrorazione della pelle sottile del sopracciglio; una seconda seduta dopo 9–12 mesi aggiunge densità dove serve, invece di sovraccaricare subito.",
        },
      ],
    },
    journey: {
      heading: "Dal disegno alla forma definitiva",
      steps: [
        {
          name: "Disegno sul viso",
          text:
            "Il sopracciglio si disegna con te seduto, misurato rispetto all'altro lato e alle proporzioni del viso, e si concorda prima di prelevare qualsiasi innesto.",
        },
        {
          name: "Intervento",
          text:
            "Anestesia locale. Estrazione dalla zona donatrice, poi impianto con aghi fini. Tre-quattro ore per entrambe le sopracciglia.",
        },
        {
          name: "I primi dieci giorni",
          text:
            "Piccole croste; niente trucco sulla zona, niente sfregamenti, non dormire a faccia in giù. Il gonfiore si risolve in una settimana.",
        },
        {
          name: "Dalla terza all'ottava settimana",
          text:
            "La maggior parte degli innesti cade, il che è normale. Per un po' il sopracciglio appare più rado che il giorno dell'intervento.",
        },
        {
          name: "Dal sesto al nono mese",
          text:
            "I nuovi peli si stabilizzano. Da quel momento crescono lunghi e vengono accorciati con piccole forbici ogni poche settimane.",
        },
      ],
    },
    risks: {
      heading: "Cosa può andare storto",
      intro: "Sul viso, piccoli errori tecnici sono visibili. Questi sono quelli da discutere.",
      items: [
        "Una direzione innaturale o una zona troppo densa che sembra un ciuffo",
        "Asimmetria tra i due sopraccigli — la simmetria perfetta non è raggiungibile",
        "Perdita di innesti su pelle cicatriziale, dove l'irrorazione è più debole",
        "Follicolite o piccole cisti nelle prime settimane",
        "Peli che crescono più veloci e più lunghi dell'originale, con necessità di tagli regolari",
      ],
      note:
        "Chiedi di vedere risultati guariti a sei mesi o più, non il giorno dopo l'intervento. Direzione e densità diventano visibili solo quando il pelo si è stabilizzato.",
    },
    faq: {
      heading: "Domande che i pazienti pongono",
      items: [
        {
          q: "Sembrerà naturale?",
          a:
            "Quando si usano capelli singoli e si rispetta l'angolo corretto, sì: a distanza di conversazione appare un sopracciglio normale. Il rischio è la densità eccessiva, per questo il primo passaggio è prudente.",
        },
        {
          q: "Posso ancora modellarle?",
          a:
            "Sì, ma con attenzione. Si evitano pinzetta e ceretta; il taglio con le forbici è il modo in cui si mantengono le sopracciglia trapiantate.",
        },
        {
          q: "Quando posso usare il trucco?",
          a: "Dopo circa 7–10 giorni, quando le croste sono sparite e la pelle è chiusa.",
        },
        {
          q: "Serve una seconda seduta?",
          a:
            "Spesso sì, per la densità, programmata dopo 9–12 mesi. La prima seduta serve a stabilire la forma, la seconda a riempirla.",
        },
      ],
    },
    ctaBand: {
      heading: "Invia le tue fotografie per un primo parere",
      text:
        "Una foto ravvicinata di ciascun sopracciglio, frontale e di tre quarti, basta per valutare cosa si può ricostruire.",
      button: "Invia le tue foto",
    },
    disclaimer:
      "Informazioni generali, non consigli medici. L'idoneità si valuta di persona; i risultati variano da paziente a paziente.",
    seoTitle: "Trapianto di sopracciglia a Istanbul | Platinya",
    seoDesc:
      "Trapianto di sopracciglia a Istanbul: capelli singoli inseriti con l'angolo naturale per ricostruire la forma. 200-400 innesti, croste via in 10 giorni.",
  },

  "/hollywood-smile": {
    title: "Hollywood Smile a Istanbul",
    eyebrow: "Odontoiatria",
    lead:
      "L'Hollywood Smile è un progetto più che una singola procedura: forma, colore e proporzioni dei denti anteriori vengono disegnati insieme e poi realizzati con faccette, corone e — dove la linea gengivale è irregolare — con il rimodellamento gengivale. La maggior parte dei progetti si conclude in cinque-sette giorni.",
    cta: "Prenota una valutazione gratuita",
    heroAlt: "Consultazione per Hollywood Smile presso Platinya Clinic",
    stats: [
      { value: "5–7 giorni", label: "Durata tipica del progetto" },
      { value: "8–20", label: "Denti di solito coinvolti" },
      { value: "10–15 anni", label: "Durata con la dovuta cura" },
    ],
    candidate: {
      heading: "Chi è un buon candidato",
      intro:
        "Il disegno deve adattarsi al viso e all'occlusione. Un sorriso che funziona in fotografia può essere sbagliato per una bocca che digrigna o per labbra che mostrano molta gengiva.",
      items: [
        "Denti anteriori scheggiati, consumati sui bordi o discromici in un modo che lo sbiancamento non modifica",
        "Piccoli spazi, o denti ruotati o leggermente disallineati ma non al punto da richiedere l'ortodonzia",
        "Corone vecchie o grandi otturazioni anteriori che non si armonizzano più con i denti vicini",
        "Una linea gengivale irregolare, in cui alcuni denti sembrano più lunghi di altri",
      ],
      note:
        "Denti e gengive devono essere sani prima di tutto. Carie attive, malattia parodontale o un'occlusione instabile si trattano prima di realizzare qualsiasi faccetta; altrimenti il nuovo lavoro viene costruito su qualcosa che si sta ancora muovendo.",
    },
    techniques: {
      heading: "Come si costruisce il sorriso",
      intro:
        "La combinazione si decide in base a quanto dente resta, quanto smalto si può risparmiare e quanto cambiamento desideri davvero.",
      items: [
        {
          name: "Disegno digitale e prova del sorriso",
          text:
            "Fotografie e una scansione intraorale servono a disegnare il sorriso sullo schermo, con proporzioni ricavate dal tuo viso e non da un modello standard. Il disegno viene stampato come mock-up e applicato temporaneamente sopra i tuoi denti, così puoi vederlo, parlarci e modificarlo prima che si faccia qualcosa di definitivo.",
        },
        {
          name: "Faccette e corone",
          text:
            "Le faccette sono sottili rivestimenti ceramici incollati sulla parte anteriore di denti integri e richiedono poca o nessuna preparazione. Le corone ricoprono tutto il dente e si usano quando è molto otturato, devitalizzato o compromesso. La maggior parte dei progetti combina le due cose: faccette al centro, corone dove un dente ha bisogno di sostegno.",
        },
        {
          name: "Rimodellamento gengivale",
          text:
            "Una linea gengivale irregolare viene rimodellata con il laser o con una lama fine. Quando i denti sono corti perché gengiva e osso sono in posizione bassa serve un allungamento della corona: un piccolo passaggio chirurgico che aggiunge settimane al progetto, non giorni.",
        },
      ],
    },
    journey: {
      heading: "Dalla consulenza al sorriso definitivo",
      steps: [
        {
          name: "Valutazione e disegno",
          text:
            "Esame, radiografie, fotografie e rilevamento del colore. Si controlla l'occlusione per usura e bruxismo. Il disegno ti viene mostrato insieme ai suoi limiti: quali denti, quanto smalto e quanto bianco è credibile rispetto alla tua pelle.",
        },
        {
          name: "Prova del sorriso",
          text:
            "Un mock-up viene applicato sui denti per uno o due giorni. È il momento di essere critici — lunghezza, simmetria, come appare quando parli — perché è ancora reversibile.",
        },
        {
          name: "Preparazione",
          text:
            "In anestesia locale lo smalto viene ridotto all'incirca dello spessore che aggiungerà la ceramica, si prendono impronte o una scansione e si applicano i restauri provvisori nello stesso giorno. I denti sono di solito sensibili per qualche giorno.",
        },
        {
          name: "Prova in bocca",
          text:
            "La ceramica torna dal laboratorio e viene verificata a secco per adattamento, colore e occlusione prima della cementazione. Piccoli aggiustamenti in questa fase sono normali; un rifacimento costa giorni.",
        },
        {
          name: "Applicazione e controllo",
          text:
            "I restauri vengono incollati, l'occlusione viene rifinita e, se digrigni, si realizza un bite notturno. Controllo dopo una o due settimane, poi igiene periodica: è sui margini che questi restauri si mantengono nel tempo.",
        },
      ],
    },
    risks: {
      heading: "Cosa può andare storto",
      intro:
        "Non è un'unica operazione ma una serie di decisioni permanenti. Queste sono quelle da conoscere prima di preparare il primo dente.",
      items: [
        "Lo smalto rimosso per le faccette non ricresce; quei denti richiederanno sempre un restauro",
        "Sensibilità al caldo e al freddo per giorni o settimane, a volte più a lungo",
        "Scheggiature o distacchi, più frequenti in chi digrigna o si morde le unghie",
        "Un colore che risulta troppo opaco o troppo uniforme, soprattutto quando si trattano molti denti insieme",
        "Infiammazione o recessione gengivale ai margini, dove la pulizia diventa difficile",
      ],
      note:
        "La delusione abituale non riguarda la ceramica ma il progetto: troppi denti, un colore troppo bianco o un'occlusione lasciata sbilanciata, così che gli anteriori portino un carico per cui non erano stati progettati.",
    },
    faq: {
      heading: "Domande che i pazienti pongono",
      items: [
        {
          q: "Quanto tempo richiede?",
          a:
            "Cinque-sette giorni in clinica per un caso semplice: due visite per preparazione e applicazione, con il laboratorio al lavoro nel mezzo. Se servono chirurgia gengivale, una ricostruzione dell'occlusione o estrazioni, il progetto si articola su settimane o mesi.",
        },
        {
          q: "Sembrerà naturale?",
          a:
            "Può esserlo, ma il naturale è una scelta, non un esito automatico. I denti veri non hanno un colore unico e piatto: il colletto è più caldo, il bordo più traslucido, la superficie ha una sua trama. Un buon ceramista riproduce tutto questo; un set molto bianco e molto opaco appare falso con qualsiasi ceramica.",
        },
        {
          q: "Devono essere trattati tutti i denti?",
          a:
            "Di solito otto-dieci denti superiori, quelli che si vedono quando sorridi e parli. Gli inferiori spesso si lasciano stare, a meno che non si vedano. Trattare più del visibile aggiunge costo e perdita di smalto senza cambiare il sorriso.",
        },
        {
          q: "Quanto durano?",
          a:
            "Le faccette ben realizzate durano comunemente dieci-quindici anni; le corone simili o più a lungo. La durata dipende meno dalla ceramica che dall'occlusione, dal bruxismo e da quanto accuratamente si puliscono i margini.",
        },
      ],
    },
    ctaBand: {
      heading: "Invia fotografie del tuo sorriso",
      text:
        "Una vista frontale, una ravvicinata dei denti e una con le labbra a riposo bastano per un primo parere su cosa è possibile, su quanti denti comporta all'incirca e su cosa richiederebbe.",
      button: "Invia le tue foto",
    },
    disclaimer:
      "Informazioni generali, non consigli medici. L'idoneità si può valutare solo dopo aver esaminato denti, gengive, occlusione e anamnesi; i risultati variano da paziente a paziente.",
    seoTitle: "Hollywood Smile a Istanbul | Platinya",
    seoDesc:
      "Hollywood Smile a Istanbul: forma, colore e proporzioni dei denti anteriori disegnati insieme, con faccette, corone e rimodellamento gengivale se serve.",
  },

  "/dental-veneers": {
    title: "Faccette in ceramica (E-max) a Istanbul",
    eyebrow: "Odontoiatria",
    lead:
      "Una faccetta è un sottile rivestimento ceramico incollato sulla parte anteriore del dente. L'obiettivo è cambiare forma e colore rimuovendo il meno smalto possibile — su un dente preparato in modo minimo si parla di circa 0,3–0,8 mm, e quello smalto non ricresce.",
    cta: "Prenota una valutazione gratuita",
    heroAlt: "Consultazione per faccette in ceramica presso Platinya Clinic",
    stats: [
      { value: "2 visite", label: "In clinica" },
      { value: "0,3–0,8 mm", label: "Smalto di solito rimosso" },
      { value: "10 anni e più", label: "Durata tipica" },
    ],
    candidate: {
      heading: "Chi è un buon candidato",
      intro:
        "Le faccette risolvono problemi di forma, colore e posizione nei denti anteriori. Non risolvono un problema di occlusione e non allineano denti affollati come fa l'ortodonzia.",
      items: [
        "Denti anteriori scheggiati, usurati o leggermente ruotati, quando il cambiamento desiderato è estetico",
        "Discromie interne al dente — fluorosi, vecchie pigmentazioni da tetraciclina, un dente devitalizzato — che lo sbiancamento non riesce a schiarire",
        "Piccoli spazi e bordi irregolari; un singolo spazio sulla linea mediana spesso si può chiudere",
        "Smalto sano: una faccetta ha bisogno di una superficie sana a cui aderire",
      ],
      note:
        "Quando l'affollamento è importante, l'ortodonzia prima è di solito il piano migliore: si tagliano meno denti e il risultato dura più a lungo. Le faccette su denti affollati risultano spesse, opache e difficili da pulire.",
    },
    techniques: {
      heading: "Quale ceramica, e perché",
      intro:
        "Il materiale si sceglie in base a quanto dente manca, quanto smalto si può conservare e se il caso riguarda un solo dente o un sorriso completo.",
      items: [
        {
          name: "E-max — disilicato di litio",
          text:
            "La scelta predefinita per la maggior parte delle faccette: disilicato di litio pressato o fresato, incollato con cemento resinoso. Abbastanza resistente per anteriori e premolari, abbastanza traslucido da comportarsi come lo smalto, e richiede circa 0,3–0,8 mm di riduzione invece di una corona completa.",
        },
        {
          name: "Ceramica feldspatica",
          text:
            "Stratificata a mano da un ceramista invece che fresata, così colore e traslucenza si costruiscono a strati. È l'opzione più simile al naturale per un singolo dente visibile; è anche più sottile, più dipendente dalla tecnica e più costosa.",
        },
        {
          name: "Rivestimento in composito",
          text:
            "Resina costruita direttamente sul dente, senza rimuovere smalto, rifinita in una sola visita e reversibile. Si macchia e si scheggia prima — cinque-sette anni sono realistici — quindi si adatta a piccole riparazioni o a una prova della forma prima di passare alla ceramica.",
        },
      ],
    },
    journey: {
      heading: "Dalla consulenza alle faccette incollate",
      steps: [
        {
          name: "Valutazione",
          text:
            "Fotografie, radiografie, colore e occlusione. La prima domanda è se l'ortodonzia darebbe un risultato migliore; la seconda è quanto smalto c'è a disposizione.",
        },
        {
          name: "Preparazione",
          text:
            "In anestesia locale lo smalto viene ridotto dello spessore della ceramica prevista, si esegue una scansione e si applicano faccette provvisorie, così i denti non restano scoperti o sensibili.",
        },
        {
          name: "Prova",
          text:
            "La ceramica viene provata con una pasta idrosolubile prima di qualsiasi incollaggio. Adattamento, colore e forma si verificano alla luce del giorno, non solo sotto la luce della sala.",
        },
        {
          name: "Incollaggio",
          text:
            "Sotto diga di gomma lo smalto viene mordenzato, la faccetta viene incollata con cemento resinoso, l'eccesso viene rimosso dai margini e l'occlusione viene rifinita. Questa parte non è reversibile.",
        },
        {
          name: "Controllo e manutenzione",
          text:
            "Un controllo dopo una o due settimane, un bite notturno se digrigni, e istruzioni di igiene che includono il filo interdentale al margine. Unghie, ghiaccio e tappi di penna sono ciò che rompe le faccette.",
        },
      ],
    },
    risks: {
      heading: "Cosa può andare storto",
      intro:
        "La procedura è piccola, ma il cambio è permanente. Questi sono i limiti da capire prima di preparare il primo dente.",
      items: [
        "La perdita di smalto è definitiva: il dente richiederà sempre una faccetta, una corona o un composito",
        "Sensibilità al freddo, a volte per settimane, soprattutto sulle preparazioni sottili",
        "Distacco o scheggiatura, di solito riparabili — anche se una riparazione in composito non è mai identica",
        "Una singola faccetta è difficile da abbinare ai denti vicini anni dopo, quando quei denti sono invecchiati o hanno cambiato colore",
        "Recessione gengivale al margine che espone il bordo, o infiammazione della polpa se la preparazione è troppo aggressiva",
      ],
      note:
        "L'argomento più forte a favore di una preparazione conservativa non sono i primi cinque anni ma la terza sostituzione: ogni rifacimento toglie un po' più di dente, e c'è un limite a quanto se ne può togliere.",
    },
    faq: {
      heading: "Domande che i pazienti pongono",
      items: [
        {
          q: "Quanto dente viene rimosso?",
          a:
            "Tra 0,3 e 0,8 mm su una faccetta E-max tipica, e a volte niente affatto se il dente è già usurato. Il valore è determinato dallo spessore che serve alla ceramica per essere resistente e da quanto il dente deve spostarsi visivamente.",
        },
        {
          q: "Le faccette si macchiano?",
          a:
            "La ceramica in sé non assorbe il colore come fa la resina. Ciò che cambia è il margine: se la giunzione con il dente è esposta o poco pulita, si scurisce. La lucidatura durante le visite periodiche la mantiene pulita.",
        },
        {
          q: "Sembreranno troppo spesse?",
          a:
            "Solo se si aggiunge troppo. Una faccetta può allungare o allargare un dente, ma non può renderlo più sottile di com'è: un dente pronunciato richiede preparazione, non più ceramica. Questo si decide in fase di progetto, non dopo l'incollaggio.",
        },
        {
          q: "Quanto durano?",
          a:
            "Dieci anni e spesso di più per faccette ben realizzate e ben mantenute. I cedimenti sono di solito scheggiature sul bordo incisale o infiltrazioni al margine, entrambi più frequenti in chi digrigna senza bite notturno.",
        },
      ],
    },
    ctaBand: {
      heading: "Invia la fotografia del dente che vuoi cambiare",
      text:
        "Una fotografia ravvicinata e a fuoco e una vista frontale bastano per dire se la faccetta, il composito o l'ortodonzia siano la strada più sensata, e quanto ti costerebbe la preparazione in termini di smalto.",
      button: "Invia le tue foto",
    },
    disclaimer:
      "Informazioni generali, non consigli medici. L'idoneità si può valutare solo dopo aver esaminato denti, gengive, occlusione e anamnesi; i risultati variano da paziente a paziente.",
    seoTitle: "Faccette in ceramica E-max a Istanbul | Platinya",
    seoDesc:
      "Faccette E-max a Istanbul: sottili rivestimenti ceramici incollati, con 0,3-0,8 mm di smalto rimosso. Due visite e una durata tipica di dieci anni.",
  },

  "/teeth-whitening": {
    title: "Sbiancamento dentale a Istanbul",
    eyebrow: "Odontoiatria",
    lead:
      "Lo sbiancamento modifica il colore dei denti naturali con il perossido — in poltrona a concentrazione controllata, oppure a casa con una mascherina su misura per due-quattro settimane. Non cambia il colore di corone, faccette o otturazioni, e questo limite condiziona tutto il piano.",
    cta: "Prenota una valutazione gratuita",
    heroAlt: "Valutazione per sbiancamento dentale presso Platinya Clinic",
    stats: [
      { value: "45–90 min", label: "Seduta in poltrona" },
      { value: "1–2 sedute", label: "Di solito sufficienti" },
      { value: "6–24 mesi", label: "Prima di un ritocco" },
    ],
    candidate: {
      heading: "Chi è un buon candidato",
      intro:
        "La maggior parte dei denti adulti sani risponde in una certa misura. Ciò che varia è il tipo di pigmentazione, il tono di partenza e se il colore stia nello smalto o più in profondità nel dente.",
      items: [
        "Denti naturali gialli o grigiastri, di solito legati all'età o a tè, caffè e tabacco",
        "Pigmentazioni che tornano poco dopo una pulizia e lucidatura professionale",
        "Prima di faccette o corone, così che la ceramica si abbini a un tono più chiaro e non il contrario",
        "Gengive sane e nessuna carie non trattata: sbiancare sopra un'otturazione infiltrata o su dentina esposta dà dolore, non bianco",
      ],
      note:
        "Corone, faccette, otturazioni in composito e rivestimenti non si schiariscono. Sbiancare una bocca con restauri visibili può farli apparire più scuri per contrasto: o si sostituiscono dopo, o si allinea il colore a loro.",
    },
    techniques: {
      heading: "In poltrona, a casa, o entrambi",
      intro:
        "I due approcci usano la stessa chimica a concentrazioni diverse. Quale sia adatto a te dipende dal tempo che hai e da come reagiscono i tuoi denti.",
      items: [
        {
          name: "Sbiancamento in poltrona",
          text:
            "Un gel di perossido di idrogeno ad alta concentrazione — in genere 25–40% — applicato con le gengive isolate e le labbra retratte, in tre o quattro cicli da 10–15 minuti. Una visita, risultato più rapido; la sensibilità raggiunge di solito il picco il giorno successivo.",
        },
        {
          name: "Sbiancamento domiciliare con mascherine su misura",
          text:
            "Si prendono le impronte e si realizzano mascherine aderenti. Il perossido di carbammide al 10–16% si indossa 30–60 minuti al giorno, oppure si usa un gel più debole durante la notte, per due-quattro settimane. Più lento e delicato, e il risultato è spesso più uniforme perché il gel raggiunge tutta l'arcata.",
        },
        {
          name: "Combinato",
          text:
            "Una seduta in poltrona per alzare il tono di base, poi mascherine a casa per una o due settimane per uniformare il colletto del dente, che è di solito la parte più scura. È il piano con cui finisce la maggior parte dei pazienti.",
        },
      ],
    },
    journey: {
      heading: "Dalla consulenza al colore finale",
      steps: [
        {
          name: "Valutazione e pulizia",
          text:
            "Si controllano carie, salute gengivale e restauri esistenti. Igiene e lucidatura vengono prima: lo sbiancamento non rimuove il tartaro, e una superficie pulita è l'unico punto di partenza corretto.",
        },
        {
          name: "Rilevamento del colore",
          text:
            "Fotografie e lettura del colore in luce standard, prima di iniziare. Senza questo, il cambiamento si può solo discutere, non misurare.",
        },
        {
          name: "Sbiancamento",
          text:
            "Una seduta in poltrona con isolamento gengivale, oppure mascherine e istruzioni scritte. Con le mascherine, i primi due o tre giorni mostrano se i denti sono sensibili e la forza del gel viene adattata di conseguenza.",
        },
        {
          name: "Controllo a due settimane",
          text:
            "Il colore si stabilizza in circa due settimane mentre i denti si reidratano, quindi il tono finale si giudica allora — non il giorno del trattamento, quando i denti appaiono sempre innaturalmente luminosi.",
        },
        {
          name: "Manutenzione",
          text:
            "Mascherine di mantenimento ogni sei-ventiquattro mesi, e un primo periodo di 48 ore ragionevole: niente caffè, vino rosso, curcuma o fumo mentre lo smalto è più ricettivo.",
        },
      ],
    },
    risks: {
      heading: "Cosa può andare storto",
      intro:
        "Lo sbiancamento è a basso rischio quando viene valutato e seguito. La maggior parte dei problemi nasce dal farlo senza l'una o l'altra cosa.",
      items: [
        "Sensibilità durante il trattamento e per un giorno o due dopo, a volte più a lungo; una recessione gengivale preesistente la peggiora",
        "Irritazione o sbiancamento delle gengive dove il gel raggiunge i tessuti molli — di solito transitoria e risolta in pochi giorni",
        "Scarsa o nessuna risposta su pigmentazioni interne, su un dente devitalizzato o sulla fluorosi",
        "I restauri mantengono il colore originale e possono apparire più scuri quando i denti intorno si schiariscono",
        "Recidiva: il risultato non è permanente, e la velocità con cui sbiadisce dipende da dieta e fumo",
      ],
      note:
        "Più gel non significa più bianco. Sedute ripetute ad alta concentrazione senza controllo aumentano la sensibilità e danno allo smalto un aspetto gessoso e sottile; le istruzioni delle mascherine esistono per un motivo.",
    },
    faq: {
      heading: "Domande che i pazienti pongono",
      items: [
        {
          q: "Danneggia lo smalto?",
          a:
            "A concentrazioni controllate, no: il perossido rimuove il pigmento senza dissolvere struttura dentale misurabile, e il minerale si recupera nei giorni successivi. L'abuso — sedute frequenti ad alta concentrazione senza valutazione — è ciò che provoca danni e sensibilità duratura.",
        },
        {
          q: "Quanto diventeranno bianchi i miei denti?",
          a:
            "Non si può promettere in anticipo. Le pigmentazioni gialle e legate all'età rispondono meglio; quelle grigie, da tetraciclina e da fluorosi rispondono poco e a volte per nulla. La maggior parte dei pazienti guadagna alcuni toni, e la risposta onesta è un intervallo, non un numero.",
        },
        {
          q: "Fa male?",
          a:
            "Il gel in sé non è doloroso. La sensibilità al freddo, e a volte un dolore acuto al colletto del dente, è comune per un giorno o due — ridotta da una concentrazione più bassa, da un tempo di applicazione più breve o da un gel desensibilizzante prima della seduta.",
        },
        {
          q: "Quanto dura?",
          a:
            "Da sei mesi a due anni per la maggior parte delle persone. Caffè, tè, vino rosso, curcuma e fumo lo riportano indietro più in fretta; una seduta di igiene ogni sei mesi e qualche mascherina di mantenimento lo mantengono stabile.",
        },
      ],
    },
    ctaBand: {
      heading: "Invia una fotografia alla luce del giorno",
      text:
        "Una fotografia scattata vicino a una finestra, senza filtri, basta di solito per dire che tipo di pigmentazione hai, se lo sbiancamento può funzionare e se i restauri vanno pianificati di conseguenza.",
      button: "Invia le tue foto",
    },
    disclaimer:
      "Informazioni generali, non consigli medici. L'idoneità si può valutare solo dopo aver esaminato denti e gengive e aver rivisto l'anamnesi; i risultati variano da paziente a paziente.",
    seoTitle: "Sbiancamento dentale a Istanbul | Platinya",
    seoDesc:
      "Sbiancamento dentale a Istanbul: seduta in poltrona da 45-90 minuti o mascherine su misura. Limiti su corone e faccette e durata del risultato.",
  },

  "/dental-implants": {
    title: "Impianti dentali a Istanbul",
    eyebrow: "Odontoiatria",
    lead:
      "Un impianto è una vite in titanio inserita nell'osso mascellare; in tre-sei mesi l'osso cresce attorno ad essa e su questa viene poi fissata una corona, un ponte o un'arcata completa. Sostituisce la radice, ed è per questo che non dipende dai denti vicini.",
    cta: "Prenota una valutazione gratuita",
    heroAlt: "Consultazione per impianti dentali presso Platinya Clinic",
    stats: [
      { value: "3–6 mesi", label: "Guarigione dell'osso prima della corona" },
      { value: "45–90 min", label: "Inserimento di un singolo impianto" },
      { value: "10–15 anni e più", label: "Funzionalità con la dovuta cura" },
    ],
    candidate: {
      heading: "Chi è un buon candidato",
      intro:
        "I fattori decisivi sono quanto osso c'è, la sua qualità, lo stato delle gengive e quanto bene è controllata un'eventuale patologia generale.",
      items: [
        "Un dente mancante, con denti vicini sani che non devono essere ridotti per un ponte",
        "Più denti mancanti nella stessa arcata, o un'arcata completa mobile o non più utilizzabile",
        "Osso sufficiente — o osso ricostruibile con un innesto o un rialzo del seno mascellare",
        "Diabete controllato, nessun fumo o disponibilità a smettere, e nessuna radioterapia o terapia antiriassorbitiva recente alla mandibola",
      ],
      note:
        "Il fumo è la cosa più utile da cambiare: raddoppia all'incirca il rischio che un impianto non si integri, e l'effetto segue la quantità fumata. Un diabete non controllato incide sulla guarigione in modo simile.",
    },
    techniques: {
      heading: "Un dente, più denti o un'arcata completa",
      intro:
        "Numero e posizione degli impianti sono decisi dall'osso disponibile e da come l'occlusione lo carica — non da quanti denti mancano.",
      items: [
        {
          name: "Impianto singolo e corona",
          text:
            "La sostituzione più conservativa per un dente mancante: nulla viene tagliato sui denti vicini. L'inserimento richiede 45–90 minuti in anestesia locale, seguiti da tre-sei mesi di guarigione prima di realizzare la corona.",
        },
        {
          name: "Ponte su impianti",
          text:
            "Per più denti mancanti in fila, due o più impianti sostengono un ponte, così i denti ai due estremi restano intatti. Meno impianti dei denti sostituiti: per questo la campata va progettata con attenzione, non allungata per risparmiare un impianto.",
        },
        {
          name: "All-on-4 e All-on-6",
          text:
            "Un'arcata completa fissata su quattro o sei impianti, con quelli posteriori inclinati per sfruttare l'osso residuo ed evitare spesso l'innesto. Di solito si può applicare un ponte provvisorio in pochi giorni; quello definitivo attende la guarigione. Non tutti ne sono candidati: decidono volume osseo, occlusione e sostegno del labbro.",
        },
      ],
    },
    journey: {
      heading: "Dalla scansione alla corona definitiva",
      steps: [
        {
          name: "Valutazione e pianificazione",
          text:
            "Una TC cone-beam misura altezza e spessore dell'osso e mostra dove si trovano il nervo e il seno mascellare. Se l'osso è sottile si pianifica prima un innesto o un rialzo del seno, che aggiunge quattro-sei mesi prima dell'inserimento.",
        },
        {
          name: "Inserimento",
          text:
            "In anestesia locale, 45–90 minuti per un impianto singolo. Si registra la stabilità e si adatta l'eventuale dente o protesi provvisoria perché non carichi l'impianto durante la guarigione.",
        },
        {
          name: "Osteointegrazione",
          text:
            "Tre-sei mesi in cui l'impianto viene lasciato in pace. La mandibola è di solito pronta prima del mascellare, e i siti innestati richiedono più tempo. Fumo e diabete scarsamente controllato rallentano questa fase.",
        },
        {
          name: "Abutment e impronta",
          text:
            "La gengiva viene modellata attorno a un abutment di guarigione, poi si esegue una scansione o un'impronta e si realizza la corona o il ponte — di solito una-tre settimane di laboratorio.",
        },
        {
          name: "Applicazione e manutenzione",
          text:
            "Il restauro viene avvitato o cementato in sede e si controlla l'occlusione. Visite di igiene ogni sei mesi, con una radiografia a un anno e poi periodicamente: la perdita ossea attorno a un impianto è silenziosa finché non è avanzata.",
        },
      ],
    },
    risks: {
      heading: "Cosa può andare storto",
      intro:
        "La chirurgia implantare è routine, ma resta chirurgia nell'osso, e i modi in cui può fallire sono specifici. Questi sono quelli che contano.",
      items: [
        "Mancata integrazione: l'impianto si mobilizza e va rimosso — più probabile in fumatori, con osso sottile e diabete non controllato",
        "Peri-implantite, perdita di osso attorno a un impianto funzionante, di solito legata alla placca; non si risolve da sola",
        "Lesione nervosa alla mandibola con intorpidimento di labbro, mento o lingua — di solito temporaneo, a volte permanente",
        "Perforazione del seno o fallimento dell'innesto nel mascellare superiore, che può richiedere un secondo intervento",
        "Frattura di componenti, vite allentata o corona scheggiata — riparabili, ma non gratuite",
      ],
      note:
        "Un impianto non è un dente. Non ha legamento, dà meno informazioni quando mordi troppo forte e, una volta perso osso attorno, non c'è modo di farlo ricrescere. Igiene e bite notturno contano più della marca sulla confezione.",
    },
    faq: {
      heading: "Domande che i pazienti pongono",
      items: [
        {
          q: "L'intervento è doloroso?",
          a:
            "Con l'anestesia locale si avvertono pressione e vibrazione più che dolore. I primi due giorni sono di gonfiore e lividi, e di solito bastano paracetamolo o ibuprofene; la maggior parte delle persone torna al lavoro d'ufficio il giorno dopo.",
        },
        {
          q: "Quanto tempo richiede tutto il percorso?",
          a:
            "Da quattro a otto mesi dall'inserimento alla corona definitiva per un impianto singolo, perché è l'osso a dettare i tempi. Un'arcata completa con All-on-4 può avere un provvisorio fisso in pochi giorni, con il ponte definitivo a quattro-sei mesi.",
        },
        {
          q: "Posso fumare?",
          a:
            "Idealmente no, durante il trattamento. Smettere almeno una settimana prima dell'inserimento e per circa otto settimane dopo migliora in modo misurabile le probabilità di integrazione; fumare in seguito aumenta il rischio a lungo termine di perdita ossea attorno all'impianto.",
        },
        {
          q: "E se non ho osso sufficiente?",
          a:
            "L'osso si può aggiungere — innesto particolato con membrana per lo spessore, innesto a blocco per difetti maggiori, o rialzo del seno per il mascellare posteriore. È una procedura separata con tempi di guarigione propri, e si pianifica dalla scansione invece di scoprirla durante l'intervento.",
        },
      ],
    },
    ctaBand: {
      heading: "Invia la tua ortopantomografia",
      text:
        "Un'ortopantomografia o una TC cone-beam recente, insieme all'indicazione di quali denti mancano, bastano per dire se l'innesto sarà probabilmente necessario, all'incirca quanti impianti servono e quanto durerebbe il percorso.",
      button: "Invia la tua radiografia",
    },
    disclaimer:
      "Informazioni generali, non consigli medici. L'idoneità si può valutare solo dopo aver esaminato la bocca, letto una TC cone-beam e rivisto l'anamnesi; i risultati variano da paziente a paziente.",
    seoTitle: "Impianti dentali a Istanbul | Platinya",
    seoDesc:
      "Impianti dentali a Istanbul: vite in titanio nell'osso e corona fissata dopo 3-6 mesi di guarigione. Cosa decide il piano e quali sono i rischi.",
  },

  "/zircon-teeth": {
    title: "Corone in zirconio a Istanbul",
    eyebrow: "Odontoiatria",
    lead:
      "Una corona in zirconio viene fresata da un blocco di biossido di zirconio e sinterizzata fino a diventare dura. Si usa dove una corona metalloceramica mostrerebbe una linea grigia sulla gengiva, ed è abbastanza resistente sia per i denti posteriori sia per gli anteriori.",
    cta: "Prenota una valutazione gratuita",
    heroAlt: "Consultazione per corone in zirconio presso Platinya Clinic",
    stats: [
      { value: "2 visite", label: "In clinica" },
      { value: "5–7 giorni", label: "Tempo di laboratorio" },
      { value: "10–15 anni", label: "Durata tipica" },
    ],
    candidate: {
      heading: "Chi è un buon candidato",
      intro:
        "Lo zirconio si sceglie per la resistenza, per l'estetica senza metallo o per entrambe. Non è automaticamente migliore di una buona corona metalloceramica: è diverso.",
      items: [
        "Denti molto otturati, devitalizzati o incrinati che necessitano di una copertura completa",
        "Denti posteriori sotto carico elevato, dove una corona interamente ceramica sottile si scheggerebbe",
        "Denti anteriori visibili, dove la linea gengivale deve restare libera da metallo",
        "Sensibilità accertata ai metalli, o una corona metalloceramica esistente con un margine scuro visibile",
      ],
      note:
        "Una corona ha bisogno di abbastanza dente per sostenersi. Se sopra la gengiva ne resta molto poco, il dente può richiedere prima una ricostruzione del moncone o un allungamento della corona; una corona non può sostituire all'infinito la struttura dentale mancante.",
    },
    techniques: {
      heading: "Monolitico o stratificato",
      intro:
        "Entrambi sono zirconio. La differenza è se l'intera corona è dello stesso materiale oppure un nucleo resistente con porcellana sopra, e questo decide come appare e come cede.",
      items: [
        {
          name: "Zirconio monolitico",
          text:
            "L'intera corona è zirconio fresato, sinterizzato e lucidato. È l'opzione più resistente per i molari e per chi digrigna; meno traslucido della ceramica stratificata, quindi su un dente anteriore può risultare piatto se tono e texture della superficie non sono curati con attenzione.",
        },
        {
          name: "Zirconio stratificato",
          text:
            "Un nucleo in zirconio con porcellana costruita sopra. Migliore sul frontale, dove la luce deve attraversare il dente, ma la porcellana di rivestimento può scheggiarsi: è il cedimento tipico di questo disegno. Un compromesso ragionevole su premolari e denti visibili.",
        },
        {
          name: "Metalloceramica, per confronto",
          text:
            "Una cappa metallica con porcellana fusa sopra: prevedibile, più economica e molto collaudata. La sua debolezza è estetica — un nucleo opaco e, negli anni, una linea grigia dove la gengiva si ritira dal margine metallico.",
        },
      ],
    },
    journey: {
      heading: "Dalla preparazione alla corona cementata",
      steps: [
        {
          name: "Valutazione",
          text:
            "Si stabilisce prima perché il dente ha bisogno di una corona: un'incrinatura, una grande otturazione vecchia, una terapia canalare. Quanto dente resta sopra la gengiva decide se una corona è sufficiente.",
        },
        {
          name: "Preparazione",
          text:
            "In anestesia locale il dente viene ridotto di 1–1,5 mm, di più dove verrà stratificata la porcellana. Si esegue una scansione o un'impronta e si applica una corona provvisoria, così il dente è protetto e non si muove.",
        },
        {
          name: "Progetto e fresatura",
          text:
            "La corona viene progettata in CAD, fresata dal blocco di zirconio e sinterizzata ad alta temperatura, poi colorata e smaltata. È qui che si definisce il tono: un colore rilevato sotto la luce della sala apparirà sbagliato alla luce del giorno.",
        },
        {
          name: "Prova e cementazione",
          text:
            "Adattamento, punti di contatto e colore si verificano prima della cementazione. La corona viene poi posizionata con cemento resinoso o vetroionomerico e l'occlusione viene rifinita finché i contatti non risultano uniformi.",
        },
        {
          name: "Controllo",
          text:
            "Un controllo dopo una o due settimane, soprattutto per l'occlusione. Se ci sono segni di digrignamento si realizza un bite notturno: una corona protegge il dente, non protegge se stessa da un carico eccessivo.",
        },
      ],
    },
    risks: {
      heading: "Cosa può andare storto",
      intro:
        "Lo zirconio è resistente, ma una corona è un restauro su un dente che ha già ceduto una volta. Questi sono i problemi realistici.",
      items: [
        "La corona può staccarsi se il moncone è corto o il cemento è compromesso — di solito si può ricementare",
        "Scheggiatura della porcellana stratificata, più spesso su una corona sottile o sottoposta a carico elevato",
        "Lo zirconio è più duro dello smalto e può usurarlo nel corso degli anni, soprattutto se la superficie non è lucidata",
        "Una corona monolitica può apparire opaca o troppo uniforme sul frontale, particolarmente in luce intensa",
        "Infiammazione della polpa, o necessità di terapia canalare, dopo la preparazione di un dente già compromesso",
      ],
      note:
        "Una corona vale quanto ciò che c'è sotto. Se il dente è incrinato sotto la gengiva o resta pochissima struttura, l'opzione onesta può essere l'estrazione e un impianto invece di una terza corona sullo stesso dente.",
    },
    faq: {
      heading: "Domande che i pazienti pongono",
      items: [
        {
          q: "È meglio della metalloceramica?",
          a:
            "Sulla linea gengivale sì: non c'è un colletto metallico, quindi non compare una linea grigia quando la gengiva si ritira. Per colore e traslucenza, una ceramica ben stratificata può ancora apparire migliore. Lo zirconio monolitico vince sulla resistenza, non sul realismo.",
        },
        {
          q: "Lo zirconio si rompe?",
          a:
            "Una corona monolitica raramente si rompe come blocco unico: è la corona ceramica più resistente in uso corrente. Il cedimento comune è la scheggiatura dello strato di porcellana su una corona stratificata, riparabile ma non invisibile.",
        },
        {
          q: "Si può usare sui denti posteriori?",
          a:
            "Sì, è il suo vantaggio principale. I molari sopportano il carico maggiore e lo zirconio lo gestisce meglio della vetroceramica. Per un secondo molare, una corona monolitica è di solito la scelta sensata.",
        },
        {
          q: "Quanto durerà?",
          a:
            "Dieci-quindici anni è un'aspettativa ragionevole, a volte di più. Il limite raramente è lo zirconio in sé: è il dente sottostante, il margine gengivale e se l'occlusione è controllata.",
        },
      ],
    },
    ctaBand: {
      heading: "Invia una fotografia del dente",
      text:
        "Una fotografia ravvicinata e una radiografia del dente bastano per dire se una corona in zirconio, un onlay o un'estrazione siano la riparazione più sensata, e perché.",
      button: "Invia le tue foto",
    },
    disclaimer:
      "Informazioni generali, non consigli medici. L'idoneità si può valutare solo dopo aver esaminato dente, gengive e occlusione e aver rivisto l'anamnesi; i risultati variano da paziente a paziente.",
    seoTitle: "Corone in zirconio a Istanbul | Platinya",
    seoDesc:
      "Corone in zirconio a Istanbul: fresate e sinterizzate, senza colletto metallico sulla gengiva. Monolitico o stratificato, tempi e limiti spiegati.",
  },

  "/periodontics": {
    title: "Cura delle gengive (parodontologia) a Istanbul",
    eyebrow: "Odontoiatria",
    lead:
      "La malattia gengivale inizia come un'infiammazione che sanguina quando ti lavi i denti e può finire con denti che si muovono e si perdono. Il trattamento rimuove il deposito batterico dalla superficie della radice e poi lo tiene lontano. La malattia si controlla, non si guarisce.",
    cta: "Prenota una valutazione gratuita",
    heroAlt: "Esame parodontale presso Platinya Clinic",
    stats: [
      { value: "1–4 visite", label: "Levigatura e curettage" },
      { value: "6–8 settimane", label: "Prima della rivalutazione" },
      { value: "3–6 mesi", label: "Intervallo di mantenimento" },
    ],
    candidate: {
      heading: "Chi ha bisogno di trattamento",
      intro:
        "Quasi chiunque abbia gengive che sanguinano è candidato a una terapia iniziale. Ciò che cambia il piano è la profondità delle tasche e quanto osso è già stato perso.",
      items: [
        "Sanguinamento quando ti lavi i denti o usi il filo, anche senza dolore",
        "Alito cattivo persistente o sapore metallico, con tartaro visibile sulla linea gengivale",
        "Gengive ritirate, o denti che sembrano più lunghi di prima",
        "Tasche più profonde di 4 mm alla sondatura, o denti che hanno iniziato a muoversi",
      ],
      note:
        "Il fumo nasconde i segni: restringe i vasi, quindi le gengive sanguinano meno mentre la malattia continua. Anche diabete e gravidanza modificano la risposta, ed è per questo che si chiede di entrambi.",
    },
    techniques: {
      heading: "Pulizia, chirurgia o innesto",
      intro:
        "Quasi ogni caso inizia con lo stesso passo — rimuovere ciò che sta sulla radice. Il resto lo decide ciò che il tessuto fa dopo.",
      items: [
        {
          name: "Levigatura e curettage radicolare",
          text:
            "Pulizia profonda in anestesia locale, di solito un quadrante alla volta, che rimuove tartaro e depositi batterici da sotto la linea gengivale. È il trattamento per la maggior parte dei casi; la chirurgia si considera solo se le tasche restano profonde dopo.",
        },
        {
          name: "Curettage a cielo aperto e chirurgia a lembo",
          text:
            "Quando le tasche restano profonde dopo la terapia iniziale, la gengiva viene sollevata, le superfici radicolari vengono pulite sotto visione diretta e il tessuto viene riposizionato. È riservata ai siti che non hanno risposto, non usata come primo passo.",
        },
        {
          name: "Innesto gengivale per recessione",
          text:
            "Quando una radice è esposta o sensibile, o la recessione progredisce, si preleva tessuto dal palato e si innesta sopra la radice. Copre la radice e ispessisce la gengiva; non restituisce l'osso già perso.",
        },
      ],
    },
    journey: {
      heading: "Dal rilevamento al mantenimento",
      steps: [
        {
          name: "Rilevamento parodontale",
          text:
            "Profondità di sondaggio per ogni dente, indici di sanguinamento, mobilità e radiografie per il livello osseo. È questo registro che rende misurabile il cambiamento: senza, il trattamento si giudica a impressione.",
        },
        {
          name: "Terapia iniziale",
          text:
            "Levigatura e curettage in una-quattro sedute, a una o due settimane di distanza, con anestesia locale dove le tasche sono profonde. La tecnica di spazzolamento viene corretta nello stesso periodo, perché la pulizia compra solo un nuovo inizio.",
        },
        {
          name: "Rivalutazione a sei-otto settimane",
          text:
            "Le tasche vengono misurate di nuovo. Quelle poco profonde spesso migliorano di uno o due millimetri; quelle profonde spesso no, e sono i siti che richiedono una decisione.",
        },
        {
          name: "Chirurgia, se necessaria",
          text:
            "Pianificata solo per i siti che non hanno risposto e solo dopo la rivalutazione. È una procedura più piccola di quanto sembri, ma resta chirurgia, con tempi di guarigione propri.",
        },
        {
          name: "Mantenimento",
          text:
            "Visite ogni tre-sei mesi, con sondaggio ripetuto. È la parte che decide se i denti si mantengono: la malattia torna ovunque si lasci ricostruire indisturbato il biofilm.",
        },
      ],
    },
    risks: {
      heading: "Cosa può andare storto",
      intro:
        "La maggior parte di ciò che i pazienti chiamano complicazione è il tessuto che guarisce. I rischi veri sono altri, e vale la pena dirli chiaramente.",
      items: [
        "Le gengive si ritirano mentre l'infiammazione si spegne, quindi i denti appaiono più lunghi e le radici possono scoprirsi — è guarigione, non danno",
        "Sensibilità al freddo sulle radici esposte, a volte per settimane",
        "Sanguinamento e indolenzimento per qualche giorno dopo la pulizia profonda, e fastidio nel mangiare",
        "La malattia è cronica: senza mantenimento ritorna, e l'osso già perso non ricresce",
        "Nei casi avanzati alcuni denti possono comunque andare persi; l'obiettivo è conservare gli altri, non garantire ogni dente",
      ],
      note:
        "Il fumo è il fattore più importante che puoi cambiare: attenua la risposta al trattamento e nasconde il sanguinamento che ti avrebbe portato prima in visita. Smettere cambia la prognosi più di qualsiasi collutorio.",
    },
    faq: {
      heading: "Domande che i pazienti pongono",
      items: [
        {
          q: "La pulizia profonda mi mobilizzerà i denti?",
          a:
            "No. I denti possono sembrare mobili per qualche giorno perché il tartaro che li sosteneva è stato rimosso e il gonfiore si è ridotto; si stabilizzano man mano che il tessuto guarisce. Dove la perdita ossea è avanzata, il dente era già mobile prima del trattamento.",
        },
        {
          q: "È una guarigione?",
          a:
            "No, è un controllo. La parodontite non passa, ma può essere tenuta ferma. Il mantenimento ogni tre-sei mesi è ciò che la tiene ferma, e saltarlo è la ragione più comune per cui i denti si perdono in seguito.",
        },
        {
          q: "Fa male?",
          a:
            "La pulizia si esegue in anestesia locale, quindi non durante. Dopo, le gengive sono dolenti per due o tre giorni e le radici possono essere sensibili al freddo per qualche settimana; entrambe si risolvono con normali analgesici e un dentifricio desensibilizzante.",
        },
        {
          q: "Ogni quanto devo tornare?",
          a:
            "Ogni tre mesi se le tasche erano profonde, se fumi o se il diabete non è ben controllato; ogni sei mesi nei casi più lievi. L'intervallo si stabilisce alla rivalutazione, dalle misure e non da una regola.",
        },
      ],
    },
    ctaBand: {
      heading: "Invia una fotografia delle tue gengive",
      text:
        "Una fotografia della linea gengivale e una radiografia recente bastano per un primo parere su se si tratti di gengivite, parodontite o di qualcosa che va visto in poltrona.",
      button: "Invia le tue foto",
    },
    disclaimer:
      "Informazioni generali, non consigli medici. La malattia gengivale si diagnostica solo con sondaggio e imaging; l'idoneità al trattamento si valuta dopo la visita, e i risultati variano da paziente a paziente.",
    seoTitle: "Parodontologia a Istanbul: cura delle gengive | Platinya",
    seoDesc:
      "Cura delle gengive a Istanbul: levigatura radicolare in 1-4 sedute, rivalutazione a 6-8 settimane e mantenimento ogni 3-6 mesi. Malattia controllata.",
  },

  "/facelift-surgery": {
    title: "Lifting del viso a Istanbul (deep-plane)",
    eyebrow: "Chirurgia plastica del viso",
    lead:
      "Un lifting del viso solleva i tessuti molli del viso e del collo che sono discesi con l'età e rimuove la pelle che non li contiene più. Cambia la linea mandibolare e il collo, non la superficie della pelle.",
    cta: "Prenota una valutazione gratuita",
    heroAlt: "Consultazione per lifting del viso presso Platinya Clinic",
    stats: [
      { value: "2–4 h", label: "Durata dell'intervento" },
      { value: "1–2 notti", label: "Degenza in clinica" },
      { value: "2–3 settimane", label: "Recupero sociale" },
    ],
    candidate: {
      heading: "Chi è un buon candidato",
      intro:
        "L'intervento tratta la lassità, non le rughe. Si adatta a chi ha un peso stabile, una pelle che conserva una certa elasticità e desidera apparire come se stesso, riposato.",
      items: [
        "Guance cadenti lungo la linea mandibolare, e una piega che va dal naso alla bocca",
        "Terzo medio del viso disceso, con appiattimento sugli zigomi",
        "Pelle rilassata e bande verticali nel collo",
        "Condizioni generali compatibili con l'anestesia generale, e nessun fumo da un mese",
      ],
      note:
        "Un lifting non ferma l'invecchiamento: il viso continua a cambiare allo stesso ritmo dopo. Rughe sottili, pigmentazioni e danni solari si trattano in altro modo — laser, peeling o tossina botulinica — e spesso si combinano con la chirurgia invece di sostituirla.",
    },
    techniques: {
      heading: "Cosa si può fare e come si sceglie",
      intro:
        "Il piano nasce dal tessuto, dall'osso e dal collo, esaminati di persona con il viso a riposo e in movimento. Una fotografia non mostra la lassità.",
      items: [
        {
          name: "Lifting deep-plane",
          text:
            "Gli strati profondi del viso vengono liberati e sollevati come un'unica unità, così la trazione è sostenuta da tessuto resistente e non dalla pelle. Dà la linea mandibolare più naturale e il risultato più duraturo, ed è la tecnica usata quando il terzo medio è disceso.",
        },
        {
          name: "Lifting SMAS con cicatrice più breve",
          text:
            "Lo strato muscolare viene tensionato attraverso un'incisione più corta, senza la liberazione profonda. Meno tempo operatorio e meno gonfiore, e una buona opzione per lassità iniziali — ma agisce più sul terzo inferiore che sul terzo medio.",
        },
        {
          name: "Lifting del collo (platismoplastica)",
          text:
            "I muscoli del collo vengono avvicinati sulla linea mediana e la pelle in eccesso rimossa, attraverso una piccola incisione sotto il mento e l'incisione dietro l'orecchio. Spesso è la parte dell'intervento che i pazienti notano di più.",
        },
      ],
    },
    journey: {
      heading: "Dalla consulenza al recupero",
      steps: [
        {
          name: "Consulenza e pianificazione",
          text:
            "Il viso viene esaminato seduto e sdraiato, si valutano collo e attaccatura dei capelli e si scattano fotografie. Prima di fissare una data si prescrivono esami del sangue e, se necessario, un parere cardiologico. La cicatrice e la sua posizione si concordano in anticipo.",
        },
        {
          name: "Preparazione",
          text:
            "Si smette di fumare almeno quattro settimane prima dell'intervento: è il fattore più importante nella guarigione delle ferite al viso. Anticoagulanti e alcuni integratori vengono sospesi circa dieci giorni prima e si resta a digiuno per sei-otto ore. Organizza un aiuto a casa la prima settimana.",
        },
        {
          name: "L'intervento",
          text:
            "In anestesia generale, di solito due-quattro ore. L'incisione decorre davanti e dietro l'orecchio e entra nell'attaccatura alla tempia, quindi è nascosta dall'orecchio e dai capelli. Spesso si lascia un drenaggio per lato per uno o due giorni, e la maggior parte dei pazienti resta una o due notti.",
        },
        {
          name: "Le prime due settimane",
          text:
            "Gonfiore ed ematomi raggiungono il picco intorno al secondo-quarto giorno e poi si riducono. Si tiene la testa sollevata, si usano impacchi freddi nei primi giorni e il drenaggio viene rimosso in clinica. La maggior parte dei pazienti si sente in grado di uscire, con gli occhiali da sole, dopo sette-dieci giorni.",
        },
        {
          name: "Dalla terza alla sesta settimana, e la cicatrice",
          text:
            "Trucco e tintura dei capelli si riprendono dopo circa due settimane, l'attività fisica dopo quattro-sei. La cicatrice resta consistente e rosa per due-tre mesi, poi sbiadisce in dodici-diciotto mesi; si colloca dietro l'orecchio e, dove possibile, all'interno dell'attaccatura.",
        },
      ],
    },
    risks: {
      heading: "Cosa può andare storto",
      intro:
        "È vera chirurgia, vicino al nervo facciale, e i rischi vanno ascoltati prima della decisione, non dopo.",
      items: [
        "Ematoma — una raccolta di sangue sotto la pelle; è la complicanza più frequente e può richiedere un drenaggio",
        "Debolezza temporanea del nervo facciale, che di solito si recupera in settimane o mesi; la lesione permanente è rara",
        "Problemi di guarigione o perdita di cute, molto più probabili nei fumatori e in chi ha una cattiva circolazione",
        "Una cicatrice larga o ispessita, piccole aree di perdita di capelli lungo l'incisione, e intorpidimento davanti all'orecchio che di solito migliora nel corso dei mesi",
        "Asimmetria, o un risultato giudicato troppo teso o troppo discreto, che richiede una revisione",
      ],
      note:
        "Parlaci del fumo, del diabete, della pressione, degli anticoagulanti e di eventuali interventi o filler al viso precedenti. Filler e fili cambiano l'anatomia e il piano, e nasconderli è il modo più rapido per avere un intervento complicato.",
    },
    faq: {
      heading: "Domande che i pazienti pongono",
      items: [
        {
          q: "Sembrerò una persona diversa?",
          a:
            "L'obiettivo è che tu sembri te stesso, riposato. Un lifting solleva tessuto che è caduto; non cambia la forma del naso, degli occhi o il carattere del viso. Un aspetto evidentemente operato deriva di solito da una trazione eccessiva sulla pelle, ed è per questo che qui la tensione è affidata agli strati profondi.",
        },
        {
          q: "Quanto dura il risultato?",
          a:
            "La maggior parte dei pazienti vede il cambiamento per sette-dieci anni, e sul collo spesso più a lungo. Non è permanente, perché il viso continua a invecchiare al proprio ritmo. Mantenere il peso stabile e proteggere la pelle dal sole aiutano entrambi.",
        },
        {
          q: "Quando potrò farmi vedere in pubblico?",
          a:
            "La maggior parte delle persone è a proprio agio dopo dieci-quattordici giorni, con un gonfiore residuo facile da coprire. Il viso continua ad assestarsi per tre-sei mesi, e la forma definitiva della linea mandibolare si giudica intorno a quel periodo.",
        },
        {
          q: "Si può associare alla chirurgia delle palpebre?",
          a:
            "Spesso sì: interventi alle palpebre superiori o inferiori, un lifting delle sopracciglia o un innesto di grasso sugli zigomi vengono comunemente eseguiti nella stessa seduta. Se sia sicuro dipende dalla durata totale dell'intervento e dalla tua salute, e si decide in consulenza.",
        },
      ],
    },
    ctaBand: {
      heading: "Invia le tue fotografie per un primo parere",
      text:
        "Tre fotografie — frontale, di tre quarti e di profilo — bastano a un chirurgo per dire se un lifting è l'intervento giusto e quale tecnica sarebbe adatta. Un coordinatore ti risponde con un piano, una data e un preventivo scritto.",
      button: "Parla con un coordinatore",
    },
    disclaimer:
      "Questa pagina contiene informazioni generali, non consigli medici. L'idoneità, la tecnica e i rischi si valutano in una consulenza con un chirurgo.",
    seoTitle: "Lifting del viso a Istanbul | Platinya",
    seoDesc:
      "Lifting del viso a Istanbul: tessuti profondi sollevati, mandibola e collo ridefiniti. Una o due notti in clinica, recupero sociale in 2-3 settimane.",
  },

  "/chin-implants": {
    title: "Aumento del mento a Istanbul (impianto e genioplastica)",
    eyebrow: "Chirurgia plastica del viso",
    lead:
      "Un mento debole o sfuggente cambia l'equilibrio di tutto il viso: il naso sembra più grande, la linea mandibolare più morbida e il collo più corto. L'aumento del mento lo proietta in avanti, con un impianto, spostando l'osso o, temporaneamente, con filler.",
    cta: "Prenota una valutazione gratuita",
    heroAlt: "Consultazione per aumento del mento presso Platinya Clinic",
    stats: [
      { value: "1–2 h", label: "Durata dell'intervento" },
      { value: "1 notte", label: "Degenza in clinica" },
      { value: "1–2 settimane", label: "Gonfiore visibile" },
    ],
    candidate: {
      heading: "Chi è un buon candidato",
      intro:
        "La valutazione riguarda le proporzioni e l'occlusione, non il mento da solo. Un mento si giudica rispetto al naso, alle labbra e all'angolo della mandibola.",
      items: [
        "Un mento che, di profilo, resta indietro rispetto alla linea del labbro inferiore",
        "Una linea mandibolare che appare morbida o corta di fronte",
        "Asimmetria dopo un trauma o dopo un precedente intervento alla mandibola",
        "Un mento valutato insieme a una rinoplastica, per mantenere equilibrato il profilo",
      ],
      note:
        "Se i denti non combaciano correttamente, il problema di fondo è l'occlusione e un impianto non lo corregge. Serve una valutazione ortodontica e maxillo-facciale, e talvolta la chirurgia ortognatica — spostare la mandibola stessa — invece di un impianto davanti ad essa.",
    },
    techniques: {
      heading: "Cosa si può fare e come si sceglie",
      intro:
        "Tre interventi diversi vengono proposti con lo stesso nome. Differiscono in ciò che spostano, in quanto sono reversibili e in quanto durano.",
      items: [
        {
          name: "Impianto in silicone per il mento",
          text:
            "Un impianto morbido e solido posizionato sull'osso attraverso una piccola incisione all'interno del labbro inferiore o, talvolta, sotto il mento. Aggiunge proiezione e larghezza, richiede circa un'ora e può essere rimosso o sostituito in seguito. L'impianto appoggia sull'osso e non si fonde con esso.",
        },
        {
          name: "Genioplastica a scorrimento",
          text:
            "L'osso del mento viene tagliato, spostato in avanti — o in basso, o lateralmente — e fissato con piccole placche e viti. Usa il tuo osso, quindi non c'è un impianto che possa spostarsi, e può correggere lunghezza verticale e asimmetria che un impianto non può. Un intervento più importante, con più gonfiore.",
        },
        {
          name: "Filler di acido ialuronico",
          text:
            "Un'opzione temporanea, eseguita in clinica in meno di un'ora e senza tempi di recupero. Mostra come apparirebbe la proiezione prima di decidere per la chirurgia, e dura all'incirca nove-diciotto mesi. Non può correggere un osso corto o asimmetrico.",
        },
      ],
    },
    journey: {
      heading: "Dalla consulenza al recupero",
      steps: [
        {
          name: "Consulenza e pianificazione",
          text:
            "Fotografie di profilo, misurazione del viso ed esame dell'occlusione. Dove si sposta l'osso, o se l'occlusione è in dubbio, si prescrivono una teleradiografia o una TC. Dimensione e forma dell'impianto si scelgono sul modello del tuo viso.",
        },
        {
          name: "Preparazione",
          text:
            "Esami del sangue e un controllo odontoiatrico se l'incisione sarà all'interno della bocca: denti e gengive devono essere sani prima di un intervento intraorale. Si smette di fumare quattro settimane prima. Gli anticoagulanti vengono sospesi circa dieci giorni prima e si resta a digiuno per sei-otto ore.",
        },
        {
          name: "L'intervento",
          text:
            "In anestesia generale o sedazione profonda, una-due ore. L'impianto viene inserito attraverso un'incisione all'interno del labbro inferiore, quindi non c'è cicatrice sulla pelle; l'incisione viene chiusa con punti riassorbibili. La maggior parte dei pazienti resta una notte.",
        },
        {
          name: "La prima settimana",
          text:
            "Il gonfiore raggiunge il picco a quarantotto-settantadue ore, e labbro inferiore e mento risultano rigidi e intorpiditi. Cibi morbidi, nessuna masticazione sui denti anteriori, risciacquo dopo ogni pasto e sonno con la testa sollevata. Gli ematomi possono scendere lungo il collo e si risolvono in una settimana.",
        },
        {
          name: "Dalla seconda alla sesta settimana",
          text:
            "La maggior parte del gonfiore è sparita a due-tre settimane, e il resto si assesta in tre mesi. L'intorpidimento del labbro inferiore migliora gradualmente, a volte nell'arco di diversi mesi. Sport di contatto e cure dentarie richiedono circa sei settimane.",
        },
      ],
    },
    risks: {
      heading: "Cosa può andare storto",
      intro:
        "Il mento è vicino al nervo mentoniero e l'incisione è accanto alla bocca: entrambe le cose determinano l'elenco dei rischi.",
      items: [
        "Infezione, più probabile con un'incisione all'interno della bocca; un impianto infetto di solito va rimosso",
        "Alterazione della sensibilità di labbro inferiore e mento, per stiramento o contusione del nervo mentoniero — di solito temporanea, a volte no",
        "Spostamento o dislocazione dell'impianto, o un bordo percepibile lungo l'osso; oppure asimmetria e una proiezione giudicata eccessiva o insufficiente, che richiede una revisione",
        "Riassorbimento osseo sotto un impianto di vecchia data, che negli anni può renderne meno stabile la sede",
        "Per la genioplastica: sanguinamento, lesione delle radici dentarie e problemi con le placche di fissazione",
      ],
      note:
        "Parlaci di precedenti interventi a mento o mandibola, di trattamenti ortodontici, di malattia gengivale e di eventuali patologie autoimmuni. Dicci anche se digrigni o hai dolore all'articolazione temporo-mandibolare: l'articolazione lavora diversamente dopo lo spostamento del mento.",
    },
    faq: {
      heading: "Domande che i pazienti pongono",
      items: [
        {
          q: "Si capirà che l'ho fatto?",
          a:
            "L'obiettivo è la proporzione, non la dimensione. Un impianto scelto per il tuo viso si legge come una mandibola più definita, non come un mento. L'incisione è all'interno del labbro, quindi non c'è cicatrice sul viso; il compromesso è un breve periodo di gonfiore e un labbro inferiore intorpidito.",
        },
        {
          q: "Impianto o genioplastica: quale è meglio?",
          a:
            "L'impianto è più rapido, reversibile e adatto ad aggiungere proiezione in avanti. La genioplastica sposta il tuo osso, quindi può allungare il mento, correggere un'asimmetria ed evitare un corpo estraneo, al prezzo di un intervento più importante. La risposta giusta dipende da cosa è effettivamente corto, e questo si misura, non si ipotizza.",
        },
        {
          q: "Quanto dura un impianto?",
          a:
            "Non ci si aspetta che un impianto in silicone debba essere sostituito, e molti restano in sede per decenni. Non è permanente nel senso che non richieda mai attenzione: può essere rimosso o sostituito, e va controllato se diventa dolente, si sposta o se il mento cambia forma.",
        },
        {
          q: "Si può fare insieme a un intervento al naso?",
          a:
            "Sì, ed è spesso il piano migliore: il profilo è una relazione tra naso e mento, e cambiare solo uno dei due può far apparire sbagliato l'altro. L'intervento combinato è più lungo, quindi si programma come un'unica procedura con un'unica convalescenza.",
        },
      ],
    },
    ctaBand: {
      heading: "Invia le tue fotografie per un primo parere",
      text:
        "Un profilo e una vista frontale bastano per dire se il problema è il mento e se la strada sensata sia l'impianto, l'osso o il filler. Un coordinatore ti risponde con un piano e un preventivo scritto.",
      button: "Parla con un coordinatore",
    },
    disclaimer:
      "Questa pagina contiene informazioni generali, non consigli medici. L'idoneità, la tecnica e i rischi si valutano in una consulenza con un chirurgo.",
    seoTitle: "Aumento del mento a Istanbul | Platinya",
    seoDesc:
      "Aumento del mento a Istanbul: impianto in silicone, genioplastica o filler per la proiezione del profilo. Una notte in clinica, gonfiore 1-2 settimane.",
  },

  "/blepharoplasty": {
    title: "Blefaroplastica a Istanbul",
    eyebrow: "Chirurgia plastica del viso",
    lead:
      "La blefaroplastica rimuove la pelle in eccesso delle palpebre superiori e il grasso che rende le palpebre inferiori stanche e gonfie. È uno degli interventi più piccoli del viso, e uno dei più facili da sbagliare.",
    cta: "Prenota una valutazione gratuita",
    heroAlt: "Consultazione per blefaroplastica presso Platinya Clinic",
    stats: [
      { value: "1–2 h", label: "Durata dell'intervento" },
      { value: "5–7 giorni", label: "Rimozione dei punti" },
      { value: "7–10 giorni", label: "Ritorno in pubblico" },
    ],
    candidate: {
      heading: "Chi è un buon candidato",
      intro:
        "L'intervento tratta pelle e grasso, non il colore né la qualità della pelle. Le occhiaie da pigmento, o lo svuotamento sotto l'occhio, sono un problema diverso con una risposta diversa.",
      items: [
        "Palpebre superiori cadenti, o pelle che appoggia sulle ciglia e restringe il campo visivo",
        "Pelle della palpebra superiore con pieghe, pesante o asimmetrica",
        "Palpebre inferiori gonfie per grasso che si è spostato in avanti, non per liquidi",
        "Pelle rilassata della palpebra inferiore, con o senza un'ernia di grasso visibile",
      ],
      note:
        "Occhio secco, oftalmopatia tiroidea, glaucoma e pressione alta cambiano il piano, e alcuni sono un motivo per attendere. Una patologia tiroidea deve essere stabile prima dell'intervento: operare su un'oftalmopatia attiva può peggiorarla.",
    },
    techniques: {
      heading: "Cosa si può fare e come si sceglie",
      intro:
        "Palpebre superiori e inferiori sono decisioni separate. Molti pazienti hanno bisogno di una sola delle due, e fare più del necessario è il modo in cui le palpebre finiscono per apparire svuotate.",
      items: [
        {
          name: "Blefaroplastica superiore",
          text:
            "Una sottile incisione nella piega naturale, rimozione della pelle in eccesso e di una striscia di muscolo; il grasso viene ridotto solo dove è in ernia. La cicatrice si colloca nella piega e sbiadisce in tre-sei mesi. È la parte che amplia il campo visivo.",
        },
        {
          name: "Palpebra inferiore, via transcongiuntivale",
          text:
            "Il grasso viene rimosso attraverso l'interno della palpebra, quindi non c'è incisione cutanea né cicatrice esterna. Adatta alle ernie di grasso con buon tono cutaneo; non rimuove la pelle in eccesso. Spesso si associa al riposizionamento del grasso per riempire il solco.",
        },
        {
          name: "Palpebra inferiore, via esterna con cantopessi",
          text:
            "Un'incisione appena sotto le ciglia rimuove pelle e grasso, e l'angolo palpebrale viene sostenuto perché non scenda. Si usa quando c'è un reale eccesso di cute, ed è la tecnica in cui il rischio di palpebra retratta va gestito con attenzione.",
        },
      ],
    },
    journey: {
      heading: "Dalla consulenza al recupero",
      steps: [
        {
          name: "Consulenza e pianificazione",
          text:
            "Le palpebre vengono esaminate a occhi aperti e chiusi, si misura la quantità di pelle da conservare e si valuta l'occhio secco. Si scattano fotografie. In caso di dubbio sul film lacrimale o sulla tiroide, si organizza un parere oculistico prima di fissare una data.",
        },
        {
          name: "Preparazione",
          text:
            "Anticoagulanti, aspirina e alcuni integratori vengono sospesi circa dieci giorni prima, e si smette di fumare quattro settimane prima. Si resta a digiuno per sei-otto ore. Organizza chi ti riporti a casa: gli occhi sono gonfi e non è possibile guidare.",
        },
        {
          name: "L'intervento",
          text:
            "Anestesia locale con sedazione leggera, oppure anestesia generale, una-due ore per entrambe le palpebre. Con l'anestesia locale resti sveglio e puoi parlare con il chirurgo. I punti sono sottili e vengono rimossi dopo cinque-sette giorni; alcuni sono riassorbibili.",
        },
        {
          name: "La prima settimana",
          text:
            "Ematomi e gonfiore sono attesi, e nelle prime tre-quattro giornate possono essere notevoli. Impacchi freddi, testa sollevata e colliri. La vista è offuscata per l'unguento più che per l'intervento. Niente lenti a contatto per circa due settimane.",
        },
        {
          name: "Dalla seconda alla dodicesima settimana",
          text:
            "La maggior parte delle persone è presentabile dopo sette-dieci giorni, con trucco a partire dal decimo circa. Il gonfiore residuo si assesta in quattro-sei settimane e la cicatrice si ammorbidisce in tre-sei mesi. In quel periodo la protezione solare sulle palpebre è importante.",
        },
      ],
    },
    risks: {
      heading: "Cosa può andare storto",
      intro:
        "La chirurgia delle palpebre ha un elenco breve di rischi, e uno di essi è un'emergenza. Vale la pena leggerli tutti prima dell'intervento.",
      items: [
        "Ectropion o retrazione della palpebra inferiore — la palpebra si abbassa, l'occhio non si chiude completamente e diventa secco e irritato; può richiedere una revisione",
        "Asimmetria tra i due lati, o rimozione di troppo tessuto, difficile da correggere",
        "Un ematoma retrobulbare — raro, ma pericoloso per la vista, e motivo di rientro immediato",
        "Diplopia, da lesione dei muscoli che muovono l'occhio; di solito temporanea, raramente permanente",
        "Cicatrici visibili o ispessite, e piccole cisti lungo la linea di incisione",
      ],
      note:
        "Parlaci di occhio secco, uso di lenti a contatto, patologie tiroidee, glaucoma, disturbi della coagulazione e di qualsiasi anticoagulante, inclusi aspirina e olio di pesce. Dicci anche se hai fatto filler o laser intorno agli occhi: cambia il comportamento dei tessuti.",
    },
    faq: {
      heading: "Domande che i pazienti pongono",
      items: [
        {
          q: "Cambierà la forma dei miei occhi?",
          a:
            "La forma è determinata da palpebre e sopracciglia, e l'intervento si progetta attorno a esse. Rimuovere pelle apre l'occhio; non dovrebbe renderlo più rotondo o spaventato. Se il sopracciglio è basso, sollevarlo invece di togliere più pelle è spesso la risposta giusta.",
        },
        {
          q: "Può togliere le occhiaie?",
          a:
            "In parte, e solo se l'oscurità è un'ombra prodotta da un'ernia di grasso o da uno svuotamento. L'oscurità da pigmento cutaneo non cambia con la chirurgia e si tratta con creme, peeling o laser. È l'equivoco più comune su questo intervento.",
        },
        {
          q: "Quanto dura il risultato?",
          a:
            "Di solito cinque-dieci anni, talvolta più a lungo per le palpebre superiori. La pelle continua a invecchiare e il sopracciglio continua a scendere, quindi il risultato è un miglioramento, non uno stato permanente. A volte, anni dopo, si esegue un secondo intervento più piccolo.",
        },
        {
          q: "Superiore o inferiore: di quale ho bisogno?",
          a:
            "Lo decide l'esame. La caduta e un campo visivo ristretto indicano la palpebra superiore; il gonfiore e un'ombra sotto l'occhio indicano quella inferiore. A molti pazienti se ne propone una sola, e combinarle è una decisione tanto sui tempi di guarigione quanto sul risultato.",
        },
      ],
    },
    ctaBand: {
      heading: "Invia le tue fotografie per un primo parere",
      text:
        "Una vista frontale a occhi aperti e una a occhi chiusi con delicatezza bastano a un chirurgo per valutare quale palpebra richiede l'intervento e quanta pelle si può conservare in sicurezza. Un coordinatore risponde con un piano e un preventivo scritto.",
      button: "Parla con un coordinatore",
    },
    disclaimer:
      "Questa pagina contiene informazioni generali, non consigli medici. L'idoneità, la tecnica e i rischi si valutano in una consulenza con un chirurgo.",
    seoTitle: "Blefaroplastica a Istanbul | Platinya",
    seoDesc:
      "Blefaroplastica a Istanbul: pelle in eccesso delle palpebre superiori e grasso delle inferiori. Punti rimossi in 5-7 giorni, vita sociale in 7-10 giorni.",
  },

  "/silicone": {
    title: "Aumento del seno con protesi in silicone a Istanbul",
    eyebrow: "Rimodellamento corporeo",
    lead:
      "L'aumento del seno aggiunge volume e migliora la simmetria con una protesi inserita dietro il tessuto mammario o dietro il muscolo. Cambia dimensione e forma; non solleva un seno che è già caduto.",
    cta: "Prenota una valutazione gratuita",
    heroAlt: "Consultazione per aumento del seno presso Platinya Clinic",
    stats: [
      { value: "1–2 h", label: "Durata dell'intervento" },
      { value: "1 notte", label: "Degenza in clinica" },
      { value: "4–6 settimane", label: "Senza attività sportiva" },
    ],
    candidate: {
      heading: "Chi è un buon candidato",
      intro:
        "Il punto di partenza è il tessuto che hai — il suo spessore, la sua elasticità e la posizione del capezzolo — non la coppa che desideri. La protesi si sceglie per adattarsi al torace.",
      items: [
        "Seno naturalmente piccolo, o una dimensione che non ha mai corrisposto al resto della figura",
        "Asimmetria evidente tra i due lati",
        "Volume perso dopo l'allattamento o dopo una perdita di peso, con la pelle ancora tonica",
        "Un seno vuoto nel polo superiore, dove una protesi modesta ripristina il profilo",
      ],
      note:
        "Se il capezzolo si trova sulla piega sottomammaria o sotto di essa, il problema è una ptosi e una protesi da sola non lo corregge: può peggiorarlo. Serve un lifting, con o senza protesi. Prima dell'intervento si programma una mammografia o un'ecografia in base all'età e alla familiarità, e qualsiasi nodulo viene indagato prima.",
    },
    techniques: {
      heading: "Cosa si può fare e come si sceglie",
      intro:
        "Si prendono tre decisioni insieme: cosa si inserisce, dove si colloca e come si inserisce. Ognuna cambia l'aspetto, la convalescenza e il rischio.",
      items: [
        {
          name: "La protesi: rotonda o anatomica",
          text:
            "Le protesi moderne sono riempite con un gel di silicone coesivo che mantiene la forma. Le protesi rotonde danno pienezza nel polo superiore; quelle anatomiche, a goccia, sono sagomate per seguire la pendenza naturale e di solito sono testurizzate per impedirne la rotazione. Superficie e forma si scelgono con il chirurgo, ed entrambe comportano compromessi.",
        },
        {
          name: "Il piano: sotto il muscolo o dual-plane",
          text:
            "La collocazione dietro il muscolo pettorale nasconde il bordo della protesi ed è adatta ai tessuti sottili; il dual-plane libera la parte inferiore del muscolo, così la protesi si assesta naturalmente mentre la parte superiore la copre ancora. Sopra il muscolo il recupero è più rapido, ma la protesi si nota di più nei pazienti magri.",
        },
        {
          name: "L'incisione",
          text:
            "Nella piega sotto il seno è la più comune e offre il controllo più diretto. Attorno all'areola nasconde la cicatrice nel cambio di pigmentazione, ma comporta un rischio leggermente maggiore di alterazione della sensibilità del capezzolo; attraverso l'ascella non lascia cicatrici sul seno, ma è meno precisa.",
        },
      ],
    },
    journey: {
      heading: "Dalla consulenza al recupero",
      steps: [
        {
          name: "Consulenza e pianificazione",
          text:
            "Misure del torace, qualità della pelle e posizione del capezzolo, e un confronto sulla dimensione desiderata, provata con protesi di prova e non scelta da una fotografia. Mammografia o ecografia dove indicato, esami del sangue e un piano scritto che indica la protesi.",
        },
        {
          name: "Preparazione",
          text:
            "Si smette di fumare quattro settimane prima, gli anticoagulanti e alcuni integratori circa dieci giorni prima, e si resta a digiuno per sei-otto ore. Acquista in anticipo il reggiseno post-operatorio e organizza aiuto per i primi tre-quattro giorni: sollevare pesi e guidare non sono possibili.",
        },
        {
          name: "L'intervento",
          text:
            "In anestesia generale, una-due ore. La protesi viene posizionata, la sua sede viene verificata con te seduto durante l'intervento e l'incisione viene chiusa a strati. La maggior parte dei pazienti resta una notte, con un reggiseno compressivo applicato prima della dimissione.",
        },
        {
          name: "Le prime due settimane",
          text:
            "Tensione e gonfiore sono maggiori nei primi tre-cinque giorni e i seni restano alti. Il reggiseno compressivo si indossa giorno e notte, i drenaggi sono rari e la prima doccia si programma in clinica. Dormire sulla schiena, con il busto sollevato, è più comodo.",
        },
        {
          name: "Dalla terza alla sesta settimana",
          text:
            "Il gonfiore si riduce e le protesi scendono in posizione in sei-dodici settimane. Il lavoro d'ufficio è di solito possibile dopo una-due settimane. Palestra, corsa, nuoto e sollevamento pesi richiedono quattro-sei settimane; l'allenamento della parte superiore del corpo si introduce gradualmente dopo.",
        },
      ],
    },
    risks: {
      heading: "Cosa può andare storto",
      intro:
        "Una protesi è un dispositivo, con una durata e un tasso di cedimento. Questi sono i rischi che contano, compresi quelli rari.",
      items: [
        "Contrattura capsulare — il tessuto cicatriziale attorno alla protesi si stringe, rendendo il seno duro, rotondo e talvolta dolente; si può trattare, ma può recidivare",
        "BIA-ALCL, un linfoma raro della capsula, legato soprattutto alle protesi testurizzate e che compare anni dopo come gonfiore o raccolta di liquido; si tratta rimuovendo la protesi e la capsula",
        "Rottura o perdita di gel, che può non dare alcun sintomo ed essere rilevata con l'imaging, e ondulazioni o bordi visibili attraverso la pelle sottile",
        "Infezione, che può richiedere la rimozione della protesi e una sostituzione successiva, e alterazione della sensibilità del capezzolo o del seno — spesso temporanea, a volte permanente",
        "Sanguinamento, ematoma e, raramente, trombosi — ridotti dalla mobilizzazione precoce e dalla compressione",
      ],
      note:
        "Parlaci di eventuali interventi precedenti al seno, di familiarità per tumore del seno o dell'ovaio, di malattie autoimmuni e di fumo. Le protesi non impediscono lo screening per il tumore del seno, ma cambiano il modo in cui si esegue la mammografia: dichiara di averle quando prenoti l'esame.",
    },
    faq: {
      heading: "Domande che i pazienti pongono",
      items: [
        {
          q: "Quanto durano le protesi?",
          a:
            "Non sono dispositivi destinati a durare tutta la vita. Molte durano dieci-quindici anni o più, ma rottura, contrattura o un cambiamento di forma possono anticipare la sostituzione. Non esiste un calendario fisso: la protesi si controlla con l'esame obiettivo e, se serve, con ecografia o risonanza, e si sostituisce se c'è un motivo.",
        },
        {
          q: "Potrò allattare?",
          a:
            "La maggior parte delle donne può, soprattutto con un'incisione nella piega e una collocazione dual-plane, che lasciano in gran parte intatti i dotti galattofori e l'innervazione. Alcune donne producono meno latte, e l'incisione periareolare comporta un rischio maggiore di alterazione della sensibilità del capezzolo. Vale la pena pianificare l'intervento pensando a una gravidanza futura.",
        },
        {
          q: "Le protesi causano il tumore del seno?",
          a:
            "Non è stato dimostrato che le protesi in silicone causino il tumore del seno. Il BIA-ALCL è un linfoma raro e distinto della capsula cicatriziale attorno alla protesi, non un tumore del seno, ed è per questo che qualsiasi nuovo gonfiore, nodulo o dolore attorno a una protesi viene indagato invece che semplicemente osservato. Il rischio è basso, ma è reale e va conosciuto.",
        },
        {
          q: "Serve invece un lifting?",
          a:
            "Se il capezzolo si trova sulla piega o sotto di essa, sì — oppure un lifting con una protesi più piccola. Una protesi aggiunge volume in avanti, non verso l'alto, e in un seno caduto può produrre una forma più pesante e più bassa. Questo si valuta in piedi, ed è la ragione più comune per cui un piano cambia in consulenza.",
        },
      ],
    },
    ctaBand: {
      heading: "Invia le tue fotografie per un primo parere",
      text:
        "Una vista frontale e una laterale, con un indumento aderente, bastano per discutere se una protesi da sola sia sufficiente, all'incirca quale volume si adatta alla tua figura e cosa comporta l'intervento. Un coordinatore risponde con un piano e un preventivo scritto.",
      button: "Parla con un coordinatore",
    },
    disclaimer:
      "Questa pagina contiene informazioni generali, non consigli medici. L'idoneità, la tecnica e i rischi si valutano in una consulenza con un chirurgo.",
    seoTitle: "Aumento del seno a Istanbul | Platinya",
    seoDesc:
      "Aumento del seno a Istanbul con protesi in silicone: volume e simmetria, una notte in clinica e 4-6 settimane senza sport. Limiti e rischi spiegati.",
  },

  "/butt-augmentation-surgery": {
    title: "Aumento dei glutei (BBL) a Istanbul",
    eyebrow: "Rimodellamento corporeo",
    lead:
      "L'aumento dei glutei cambia forma e proiezione dei glutei, spostando grasso da un'altra parte del corpo oppure inserendo una protesi. È uno degli interventi più impegnativi del rimodellamento corporeo, per il chirurgo e per la convalescenza.",
    cta: "Prenota una valutazione gratuita",
    heroAlt: "Consultazione per aumento dei glutei presso Platinya Clinic",
    stats: [
      { value: "3–5 h", label: "Durata dell'intervento" },
      { value: "1–2 notti", label: "Degenza in clinica" },
      { value: "2–3 settimane", label: "Sedersi con cautela" },
    ],
    candidate: {
      heading: "Chi è un buon candidato",
      intro:
        "Un trasferimento di grasso richiede grasso da trasferire e pelle in grado di accogliere il nuovo volume. Entrambe le cose si valutano in piedi, ed entrambe decidono se l'intervento sia possibile.",
      items: [
        "Grasso sufficiente su addome, fianchi, schiena o cosce da prelevare, con un peso stabile",
        "Glutei piatti, quadrati o senza proiezione di profilo",
        "Asimmetria, o perdita di forma dopo una perdita di peso",
        "Buon tono cutaneo, e nessuna storia di trombosi o di problemi con liposuzioni precedenti",
      ],
      note:
        "Non è un intervento per perdere peso e non sostituisce l'allenamento. Se sei sottopeso può non esserci nulla da prelevare, e la protesi resta l'unica strada, con rischi diversi. Fumo, disturbi della coagulazione e diabete non controllato sono motivi per riconsiderare.",
    },
    techniques: {
      heading: "Cosa si può fare e come si sceglie",
      intro:
        "Due interventi condividono lo stesso nome. Non sono varianti l'uno dell'altro: differiscono nel materiale, nella convalescenza e nei rischi gravi.",
      items: [
        {
          name: "Trasferimento di grasso (Brazilian butt lift)",
          text:
            "Il grasso viene aspirato da addome, fianchi o schiena, lavato e lasciato decantare, poi iniettato nei glutei con piccoli passaggi. È tessuto tuo, quindi risulta naturale e le aree donatrici vengono rimodellate contemporaneamente. Non tutto il grasso sopravvive.",
        },
        {
          name: "Protesi glutee",
          text:
            "Una protesi solida in silicone viene inserita attraverso un'incisione nella piega tra i glutei, in profondità rispetto alla fascia o nel muscolo. Dà un volume prevedibile che non si riduce, ma è un corpo estraneo con rischio di spostamento, infezione e formazione di capsula, e la cicatrice è in una zona sensibile.",
        },
        {
          name: "Combinazione e revisione",
          text:
            "Il trasferimento di grasso si può combinare con una protesi piccola, o ripetere dopo sei-dodici mesi per aggiungere volume una volta assestato il primo. La revisione di un BBL precedente è di solito più difficile del primo intervento, perché il tessuto cicatriziale modifica i piani.",
        },
      ],
    },
    journey: {
      heading: "Dalla consulenza al recupero",
      steps: [
        {
          name: "Consulenza e pianificazione",
          text:
            "Fotografie in piedi, valutazione del grasso donatore e dell'elasticità cutanea, e un'anamnesi che comprenda coagulazione, sanguinamento e interventi precedenti. Esami del sangue e, se necessario, un parere cardiologico o anestesiologico prima di fissare una data.",
        },
        {
          name: "Preparazione",
          text:
            "Si smette di fumare almeno quattro settimane prima: la nicotina incide sulla sopravvivenza del grasso e sulla guarigione. Anticoagulanti, contraccettivo orale e alcuni integratori vengono discussi e sospesi dove opportuno. Acquista indumenti larghi e un cuscino apposito, e organizza aiuto a casa: non potrai sdraiarti né sederti normalmente per settimane.",
        },
        {
          name: "L'intervento",
          text:
            "In anestesia generale, tre-cinque ore. Il grasso viene prelevato, trattato e iniettato in piccole quantità, con attenzione a restare lontano dai vasi profondi. Si applica una guaina compressiva e la maggior parte dei pazienti resta una o due notti.",
        },
        {
          name: "Le prime due settimane",
          text:
            "Si dorme a pancia in giù o su un fianco e ci si siede solo sul cuscino indicato, per brevi periodi. Le aree donatrici sono doloranti e piene di lividi, e le guaine si indossano di continuo. Camminare è incoraggiato dal primo giorno; i glutei sono gonfi e la forma non è ancora quella definitiva.",
        },
        {
          name: "Dalla terza alla dodicesima settimana",
          text:
            "Sedersi diventa comodo in due-tre settimane, guidare dopo due-tre, l'attività fisica dopo sei-otto. Il gonfiore si assesta in tre mesi; il grasso che sopravvive è permanente, ma la forma finale si giudica a tre-sei mesi.",
        },
      ],
    },
    risks: {
      heading: "Cosa può andare storto",
      intro:
        "Questo intervento ha un rischio grave che gli è specifico, e va detto chiaramente invece che accennato di passaggio.",
      items: [
        "Embolia grassosa — grasso che entra nel circolo sanguigno e raggiunge i polmoni; può essere fatale, e nessuna tecnica elimina del tutto il rischio",
        "Necrosi del grasso, cisti oleose e indurimenti nelle aree trattate, talvolta da drenare",
        "Infezione, che in un piano gluteo profondo può essere difficile da trattare e richiedere la rimozione della protesi, e sieroma o guarigione ritardata nelle aree donatrici",
        "Asimmetria, irregolarità del contorno o un risultato più piccolo del previsto, perché una parte variabile del grasso non sopravvive",
        "Trombosi o embolia polmonare, ridotte dalla mobilizzazione precoce e dalla compressione — e, con le protesi, spostamento, contrattura capsulare e cicatrici ispessite",
      ],
      note:
        "Chiedi direttamente a qualsiasi clinica come eviti l'iniezione intravascolare profonda, chi esegue l'anestesia e cosa accade in caso di complicanza. Una clinica che risponde in modo vago sull'embolia grassosa non è una clinica con cui prenotare.",
    },
    faq: {
      heading: "Domande che i pazienti pongono",
      items: [
        {
          q: "Quanto grasso sopravvive?",
          a:
            "Una proporzione variabile: spesso una parte consistente viene riassorbita e il risultato è più piccolo del volume immediatamente post-operatorio. Per questo l'intervento si pianifica in modo prudente e a volte serve una seconda seduta dopo sei-dodici mesi. Nessun chirurgo può promettere una percentuale.",
        },
        {
          q: "Quanto tempo prima di potermi sedere normalmente?",
          a:
            "Due-tre settimane sedendosi solo su un cuscino, per brevi periodi, e dormendo a pancia in giù o su un fianco. Si ritiene che la pressione prolungata nelle prime settimane riduca la sopravvivenza del grasso. Guidare richiede due-tre settimane; i voli lunghi, quattro-sei.",
        },
        {
          q: "Il BBL è pericoloso?",
          a:
            "Comporta un rischio reale di embolia grassosa, che può essere fatale, ed è un rischio più alto rispetto alla maggior parte degli interventi estetici. Si riduce con una tecnica accurata — cannule piccole, evitando il muscolo profondo e i grandi vasi, limitando il volume — ma non si elimina. È legittimo decidere che il rischio non vale la pena.",
        },
        {
          q: "Grasso o protesi: cosa è meglio?",
          a:
            "Il grasso dà una sensazione naturale e rimodella le aree donatrici, ma il volume si perde in parte e il limite è quanto grasso hai. La protesi dà un volume prevedibile senza una seconda area chirurgica, al prezzo di un corpo estraneo e di un rischio maggiore di infezione e spostamento. Di solito è la distribuzione del tuo tessuto a decidere.",
        },
      ],
    },
    ctaBand: {
      heading: "Invia le tue fotografie per un primo parere",
      text:
        "Una vista laterale e una posteriore, con indumenti aderenti, permettono a un chirurgo di valutare proiezione e grasso donatore e di dire con onestà se un trasferimento è possibile. Un coordinatore risponde con un piano e un preventivo scritto.",
      button: "Parla con un coordinatore",
    },
    disclaimer:
      "Questa pagina contiene informazioni generali, non consigli medici. L'idoneità, la tecnica e i rischi si valutano in una consulenza con un chirurgo.",
    seoTitle: "Aumento dei glutei (BBL) a Istanbul | Platinya",
    seoDesc:
      "Aumento dei glutei a Istanbul: trasferimento di grasso o protesi, proiezione e forma valutate in piedi. Una o due notti, recupero in 2-3 settimane.",
  },

  "/liposuction": {
    title: "Liposuzione a Istanbul (VASER e tumescente)",
    eyebrow: "Rimodellamento corporeo",
    lead:
      "La liposuzione rimuove il grasso da zone specifiche per cambiare il profilo del corpo. È un intervento di rimodellamento: la bilancia si muove appena, e ciò che cambia è dove si trova il grasso.",
    cta: "Prenota una valutazione gratuita",
    heroAlt: "Consultazione per liposuzione presso Platinya Clinic",
    stats: [
      { value: "1–3 h", label: "Durata dell'intervento" },
      { value: "Day surgery", label: "oppure una notte" },
      { value: "4–6 settimane", label: "Guaina compressiva" },
    ],
    candidate: {
      heading: "Chi è un buon candidato",
      intro:
        "Le due cose che decidono il risultato sono quanto grasso c'è da rimuovere e quanto bene la pelle si ritrarrà dopo. La seconda è quella che i pazienti sottovalutano.",
      items: [
        "Grasso localizzato su addome, fianchi, schiena, cosce o braccia che non è cambiato con l'allenamento",
        "Peso stabile da circa sei mesi, e vicino a quello che intendi mantenere",
        "Pelle che conserva elasticità: deve ritirarsi sul nuovo contorno",
        "Nessun disturbo della coagulazione, e nessun diabete o cardiopatia non controllati",
      ],
      note:
        "La liposuzione non è un trattamento dell'obesità e non sostituisce la perdita di peso. Se c'è molto peso da perdere, perderlo prima dà un risultato migliore e più sicuro. Se la pelle è già rilassata, rimuovere il grasso sottostante rende la lassità più evidente: è un caso per l'asportazione cutanea, non per altra liposuzione.",
    },
    techniques: {
      heading: "Cosa si può fare e come si sceglie",
      intro:
        "Tutte le liposuzioni lavorano attraverso piccole incisioni con una cannula. La differenza è come il grasso viene allentato prima di essere aspirato, e quanta superficie si tratta in una seduta.",
      items: [
        {
          name: "Liposuzione tumescente",
          text:
            "Si inietta prima un grande volume di anestetico locale diluito con adrenalina, che insensibilizza la zona, restringe i vasi e riduce il sanguinamento. Il grasso viene poi aspirato con una cannula. È la tecnica standard, e quella su cui si basano quasi tutte le altre.",
        },
        {
          name: "VASER (assistita da ultrasuoni)",
          text:
            "L'energia ultrasonora viene usata per allentare il grasso prima di rimuoverlo. Si sostiene che sia più delicata sui tessuti circostanti e che aiuti la pelle a ritrarsi, soprattutto su schiena e fianchi. È più lenta, costa di più e comporta un rischio specifico di ustioni sotto la pelle.",
        },
        {
          name: "Contorno 360°",
          text:
            "Addome, fianchi e schiena vengono trattati come un'unica unità continua, così il passaggio attorno alla vita è uniforme e non una serie di zone separate. Un intervento più lungo e un volume maggiore rimosso, quindi si pianifica con più attenzione e più tempo di recupero.",
        },
      ],
    },
    journey: {
      heading: "Dalla consulenza al recupero",
      steps: [
        {
          name: "Consulenza e pianificazione",
          text:
            "Le aree vengono disegnate in piedi, si valuta l'elasticità della pelle e si discute con onestà il volume atteso, compreso ciò che non cambierà. Esami del sangue e, se necessario, un parere cardiologico prima di fissare una data.",
        },
        {
          name: "Preparazione",
          text:
            "Si smette di fumare quattro settimane prima, gli anticoagulanti e alcuni integratori circa dieci giorni prima, e si resta a digiuno per sei-otto ore. Le guaine compressive vengono misurate e ordinate in anticipo. Organizza aiuto a casa per i primi due-tre giorni.",
        },
        {
          name: "L'intervento",
          text:
            "In sedazione o anestesia generale, una-tre ore secondo il numero di aree. Si infiltra il liquido, si aspira il grasso attraverso incisioni di pochi millimetri e la guaina viene applicata in sala. La maggior parte dei pazienti torna a casa lo stesso giorno; i volumi maggiori restano una notte.",
        },
        {
          name: "Le prime due settimane",
          text:
            "Liquido fuoriesce dalle incisioni per un giorno o due, e la guaina si indossa giorno e notte. Gli ematomi sono estesi e raggiungono il picco nella prima settimana. Si cammina dal primo giorno; il lavoro d'ufficio è di solito possibile dopo tre-sette giorni.",
        },
        {
          name: "Dalla terza alla dodicesima settimana",
          text:
            "Il gonfiore si riduce in quattro-sei settimane, e la guaina si porta per quel periodo. L'attività fisica riprende a quattro-sei settimane. Il contorno si definisce in tre-sei mesi e il risultato finale si giudica a sei-dodici.",
        },
      ],
    },
    risks: {
      heading: "Cosa può andare storto",
      intro:
        "La liposuzione è diffusa ed è comunque chirurgia, con un piccolo numero di rischi che sono gravi più che estetici.",
      items: [
        "Irregolarità del contorno, avvallamenti o asimmetria — il rilievo più frequente e il più difficile da correggere",
        "Lassità o cedimento della pelle dopo la rimozione del grasso, quando l'elasticità era già scarsa",
        "Ustioni o necrosi cutanea, in particolare con le tecniche assistite da ultrasuoni",
        "Infezione, sieroma che richiede drenaggi ripetuti e guarigione ritardata nelle sedi di incisione",
        "Trombosi, embolia polmonare ed embolia grassosa — rare, ridotte dalla mobilizzazione precoce e dalla compressione; le lesioni interne della parete addominale o degli organi sono ancora più rare e più probabili con un'aspirazione profonda aggressiva",
      ],
      note:
        "Parlaci di anticoagulanti, problemi di coagulazione, patologie cardiache o epatiche e di eventuali liposuzioni precedenti nella stessa area. C'è un limite a quanto si può rimuovere in sicurezza in una seduta; un chirurgo che accetta qualsiasi volume richiesto non sta agendo con prudenza.",
    },
    faq: {
      heading: "Domande che i pazienti pongono",
      items: [
        {
          q: "Quanto peso perderò?",
          a:
            "Molto poco, ed è voluto: il grasso pesa meno di quanto sembri e il volume sicuro in una seduta è limitato. Il cambiamento è nella forma e in come cadono i vestiti. Se l'obiettivo è perdere peso, questo è l'intervento sbagliato.",
        },
        {
          q: "Il grasso tornerà?",
          a:
            "Le cellule adipose rimosse non tornano, ma quelle rimaste possono ingrandirsi se prendi peso, e tendono a farlo in modo uniforme, quindi la forma può cambiare. Mantenere il peso stabile è ciò che protegge il risultato.",
        },
        {
          q: "Tratta la cellulite?",
          a:
            "Non in modo affidabile. La cellulite è una struttura della pelle e delle bande fibrose sottostanti, non semplicemente grasso. La liposuzione può talvolta rendere gli avvallamenti più visibili, perché rimuove il grasso che li riempiva. Diffida di chi la propone come cura della cellulite.",
        },
        {
          q: "Quando vedrò il risultato?",
          a:
            "Un cambiamento iniziale è visibile a due-tre settimane, ma il gonfiore nasconde il contorno reale più a lungo. La maggior parte del risultato c'è a tre mesi, e la forma finale a sei-dodici: è anche il momento in cui si valuterebbe un'eventuale revisione.",
        },
      ],
    },
    ctaBand: {
      heading: "Invia le tue fotografie per un primo parere",
      text:
        "Viste frontale, laterale e posteriore bastano per dire quali aree si possono trattare, all'incirca quale volume è realistico e se la pelle si ritirerà. Un coordinatore risponde con un piano e un preventivo scritto.",
      button: "Parla con un coordinatore",
    },
    disclaimer:
      "Questa pagina contiene informazioni generali, non consigli medici. L'idoneità, la tecnica e i rischi si valutano in una consulenza con un chirurgo.",
    seoTitle: "Liposuzione a Istanbul (VASER e tumescente) | Platinya",
    seoDesc:
      "Liposuzione a Istanbul: tumescente, VASER o contorno 360° per rimodellare addome e fianchi. Guaina per 4-6 settimane e risultato finale a 6-12 mesi.",
  },

  "/gynecomastia": {
    title: "Chirurgia della ginecomastia a Istanbul",
    eyebrow: "Rimodellamento corporeo",
    lead:
      "La ginecomastia è un aumento del seno maschile. L'intervento rimuove la ghiandola dietro il capezzolo, il grasso che la circonda o entrambi, ma solo dopo aver cercato la causa, perché alcune cause sono mediche e alcune reversibili.",
    cta: "Prenota una valutazione gratuita",
    heroAlt: "Consultazione per ginecomastia presso Platinya Clinic",
    stats: [
      { value: "1–2 h", label: "Durata dell'intervento" },
      { value: "Day surgery", label: "oppure una notte" },
      { value: "3–4 settimane", label: "Gilet compressivo" },
    ],
    candidate: {
      heading: "Chi è un buon candidato",
      intro:
        "La vera ginecomastia è tessuto ghiandolare, un disco consistente dietro il capezzolo, e non regredisce con l'allenamento. Il solo grasso è una pseudoginecomastia e si tratta in modo diverso.",
      items: [
        "Un disco di tessuto consistente, talvolta dolente, dietro uno o entrambi i capezzoli",
        "Un aumento stabile da due anni o più dopo la pubertà",
        "Pseudoginecomastia: grasso senza ghiandola, in una persona con peso vicino alla stabilità",
        "Fastidio, asimmetria o limitazione in ciò che indossi o fai",
      ],
      note:
        "Prima di qualsiasi intervento la causa viene esclusa. I farmaci — cannabis, steroidi anabolizzanti, alcol, alcuni antipertensivi e farmaci per la prostata — sono la causa reversibile più comune. Anche problemi ormonali, patologie tiroidee, malattie epatiche o renali e, raramente, un tumore testicolare si presentano così. Si eseguono prima esami del sangue e un esame testicolare; se si trova qualcosa, si tratta, non si opera intorno.",
    },
    techniques: {
      heading: "Cosa si può fare e come si sceglie",
      intro:
        "L'intervento si progetta su ciò che c'è davvero — ghiandola, grasso o pelle — e questi tre componenti sono presenti in proporzioni diverse in uomini diversi.",
      items: [
        {
          name: "Escissione della ghiandola",
          text:
            "La ghiandola viene rimossa attraverso un'incisione semicircolare attorno alla metà inferiore dell'areola. È l'unico modo per rimuovere il tessuto ghiandolare consistente, e l'incisione di solito guarisce bene perché segue il bordo della pigmentazione. Spesso si lascia un piccolo drenaggio per uno o due giorni.",
        },
        {
          name: "Liposuzione",
          text:
            "Si usa per la componente adiposa e per sfumare i bordi, così il torace non appare operato. Da sola non rimuove la ghiandola, ed è per questo che la sola liposuzione lascia spesso un nodulo duro dietro il capezzolo: la causa più comune di revisione.",
        },
        {
          name: "Associata all'asportazione cutanea",
          text:
            "Negli aumenti importanti, o dopo una grande perdita di peso, c'è pelle in eccesso che non si ritirerà. Viene rimossa, con la cicatrice attorno all'areola o orizzontale sul torace. Un intervento più importante, e una cicatrice che va accettata.",
        },
      ],
    },
    journey: {
      heading: "Dalla consulenza al recupero",
      steps: [
        {
          name: "Consulenza e valutazione",
          text:
            "Il torace viene esaminato sdraiato e in piedi, si distingue la ghiandola dal grasso e si esaminano i testicoli. Esami del sangue per gli ormoni e la funzionalità epatica, e un'ecografia del torace o dei testicoli dove indicato, prima di programmare qualsiasi cosa.",
        },
        {
          name: "Preparazione",
          text:
            "Qualsiasi farmaco responsabile viene sospeso d'intesa con il medico curante — mai di propria iniziativa se è prescritto. Si smette di fumare quattro settimane prima, gli anticoagulanti circa dieci giorni prima, e si resta a digiuno per sei-otto ore. Il gilet compressivo si ordina in anticipo.",
        },
        {
          name: "L'intervento",
          text:
            "In anestesia generale, una-due ore. La ghiandola viene escissa, il grasso aspirato e il contorno verificato con te seduto. Il gilet viene applicato in sala. La maggior parte dei pazienti torna a casa lo stesso giorno, alcuni restano una notte.",
        },
        {
          name: "Le prime due settimane",
          text:
            "Il gilet si indossa giorno e notte, e il drenaggio, se presente, viene rimosso in uno o due giorni. Gonfiore ed ematomi sono importanti e il torace risulta teso. Lavoro d'ufficio dopo tre-sette giorni; niente sollevamento pesi né esercizi per il torace.",
        },
        {
          name: "Dalla terza alla dodicesima settimana",
          text:
            "Il gilet continua per tre-quattro settimane in totale. Attività aerobica a tre-quattro settimane, pesi ed esercizi per il torace a sei. Il gonfiore si assesta in tre mesi, e il contorno definitivo — comprese eventuali piccole irregolarità — si giudica a sei.",
        },
      ],
    },
    risks: {
      heading: "Cosa può andare storto",
      intro:
        "La maggior parte dei rischi qui riguarda il contorno, e uno riguarda il lasciare la causa senza trattamento.",
      items: [
        "Deformità del contorno — una depressione a forma di scodella, un nodulo residuo o asimmetria tra i due lati, se si rimuove troppo o troppo poco tessuto",
        "Recidiva, se resta tessuto ghiandolare o se si continua un farmaco responsabile",
        "Intorpidimento o ipersensibilità del capezzolo, che di solito migliora nel corso dei mesi",
        "Cicatrici scadenti o allargate e, raramente, perdita del complesso areola-capezzolo se la sua irrorazione viene compromessa",
        "Trombosi, ridotta dalla mobilizzazione precoce, e infezione — più probabile nei fumatori; ematoma o sieroma possono richiedere drenaggio e influire sulla forma finale",
      ],
      note:
        "Di' con onestà cosa assumi — steroidi, cannabis, integratori, farmaci prescritti. Non è un giudizio: è la differenza tra un intervento che funziona e uno che si annulla. Se si trova una causa ormonale, viene trattata separatamente.",
    },
    faq: {
      heading: "Domande che i pazienti pongono",
      items: [
        {
          q: "È un tumore?",
          a:
            "La ginecomastia in sé non è un tumore del seno e nell'uomo è di solito benigna. Ma un nodulo unilaterale, duro, fisso o che secerne non è la stessa cosa e va indagato: è per questo che l'esame obiettivo e, se serve, l'ecografia vengono prima dell'intervento e non dopo.",
        },
        {
          q: "Tornerà?",
          a:
            "Se la ghiandola viene escissa correttamente e la causa viene rimossa, la recidiva è poco frequente. Torna più spesso quando si è fatta solo liposuzione, quando si è lasciata parte della ghiandola per preservare il capezzolo o quando steroidi e cannabis continuano. Una piccola pienezza residua non è una recidiva.",
        },
        {
          q: "Devo smettere con cannabis o steroidi?",
          a:
            "Sì, e non solo per la guarigione. Entrambi possono alimentare l'aumento, e continuarli dopo l'intervento è il modo più affidabile per annullarlo. I farmaci prescritti sono altra cosa: si modificano solo con il medico che li ha prescritti.",
        },
        {
          q: "Resterà una cicatrice visibile?",
          a:
            "L'incisione segue il bordo inferiore dell'areola e di solito sbiadisce in una linea sottile in sei-dodici mesi. Se si deve rimuovere pelle, la cicatrice è più lunga — attorno all'areola o sul torace. È permanente, ed è il principale compromesso dell'intervento.",
        },
      ],
    },
    ctaBand: {
      heading: "Invia le tue fotografie per un primo parere",
      text:
        "Una vista frontale e una laterale bastano per stabilire se si tratta di ghiandola, grasso o pelle, e se servono esami del sangue prima di tutto il resto. Un coordinatore risponde con un piano e un preventivo scritto.",
      button: "Parla con un coordinatore",
    },
    disclaimer:
      "Questa pagina contiene informazioni generali, non consigli medici. L'idoneità, la tecnica e i rischi si valutano in una consulenza con un chirurgo.",
    seoTitle: "Ginecomastia a Istanbul | Platinya",
    seoDesc:
      "Chirurgia della ginecomastia a Istanbul: ghiandola escissa e grasso aspirato, dopo aver escluso le cause. Gilet per 3-4 settimane, controllo a sei mesi.",
  },

  "/gastric-sleeve-surgery": {
    title: "Sleeve gastrico a Istanbul",
    eyebrow: "Chirurgia per la perdita di peso",
    lead:
      "Lo stomaco viene rimodellato in un tubo stretto — ne viene rimosso circa il 60–70% — così contiene molto meno e si svuota più lentamente. È uno strumento che rende appetito e porzioni più gestibili; non fa perdere peso al posto tuo.",
    cta: "Prenota una valutazione gratuita",
    heroAlt: "Consultazione per sleeve gastrico presso Platinya Clinic",
    stats: [
      { value: "1–2 h", label: "Durata dell'intervento" },
      { value: "2–3 notti", label: "Degenza in clinica" },
      { value: "12–18 mesi", label: "Fino alla stabilizzazione del peso" },
    ],
    candidate: {
      heading: "Chi è un buon candidato",
      intro:
        "La decisione non si basa solo sul peso. Dipende dall'indice di massa corporea, dalle patologie che accompagnano l'eccesso di peso, da ciò che è già stato provato sotto supervisione e dalla reale disponibilità a un follow-up di anni, non di mesi.",
      items: [
        "Un BMI di 40 o superiore, oppure di 35 o superiore con una patologia legata al peso come diabete di tipo 2, ipertensione o apnee del sonno",
        "Un BMI di 30 o superiore con diabete di tipo 2 scarsamente controllato — consentito da alcune linee guida internazionali, deciso caso per caso",
        "Precedenti tentativi strutturati di perdita di peso — dieta, attività fisica, supporto comportamentale — che non hanno retto a lungo termine",
        "Impegno a un follow-up per tutta la vita: esami del sangue, integratori e visite, compresi gli anni in cui il peso è stabile",
      ],
      note:
        "Nessun intervento viene prenotato prima di una valutazione psicologica, una valutazione anestesiologica e una valutazione dietistica. Un abuso di sostanze attivo o una patologia psichiatrica non trattata rinviano l'intervento fino al trattamento: non per una regola, ma perché altrimenti il follow-up non regge.",
    },
    techniques: {
      heading: "Come si esegue l'intervento",
      intro:
        "Il principio è lo stesso in ogni caso; ciò che cambia è il diametro del tubo lasciato e se si ripara contemporaneamente un'ernia.",
      items: [
        {
          name: "Sleeve per via laparoscopica",
          text:
            "Cinque o sei piccole incisioni, una telecamera e suturatrici che dividono lo stomaco lungo la grande curvatura. La parte aperta viene estratta attraverso uno dei port, quindi lo stomaco che resta è un tubo, non una tasca con un bypass.",
        },
        {
          name: "Calibratura: quanto è stretto il tubo",
          text:
            "Il tubo viene costruito su una sonda di calibrazione introdotta dalla bocca, in genere 36–40 French. Più stretto dà più restrizione ma anche più stenosi e reflusso; più largo ne dà meno. È una valutazione chirurgica, non una scelta del paziente.",
        },
        {
          name: "Riparazione dell'ernia iatale e reflusso",
          text:
            "Il diaframma viene ispezionato durante l'intervento e un'ernia iatale, se presente, viene riparata nella stessa seduta. Un reflusso già esistente può peggiorare dopo uno sleeve, per questo si valuta prima e talvolta cambia l'intervento scelto.",
        },
      ],
    },
    journey: {
      heading: "Dalla consulenza al follow-up a lungo termine",
      steps: [
        {
          name: "Valutazione",
          text:
            "Esami del sangue compresi ferro, B12, folati, vitamina D e funzionalità tiroidea; una gastroscopia dove indicato; una valutazione dietistica; una valutazione psicologica; e un parere anestesiologico. Solo dopo viene proposta una data.",
        },
        {
          name: "Le due settimane precedenti",
          text:
            "Una dieta ipocalorica, di solito liquida o a bassissimo contenuto energetico, riduce il fegato così che lo stomaco sia raggiungibile in sicurezza. Si smette di fumare almeno quattro settimane prima. Gli anticoagulanti vengono sospesi su indicazione.",
        },
        {
          name: "L'intervento e la degenza",
          text:
            "In anestesia generale, una-due ore. La maggior parte dei pazienti resta due-tre notti. Il primo o il secondo giorno si esegue un esame con mezzo di contrasto se c'è qualche dubbio sulla linea di sutura, e i liquidi iniziano lo stesso giorno.",
        },
        {
          name: "Le prime sei settimane",
          text:
            "Liquidi per una-due settimane, alimenti passati per due settimane, cibi morbidi per due, poi consistenze normali. Porzioni piccole, consumate lentamente, con le proteine per prime e i liquidi tenuti lontani dai pasti. Il lavoro d'ufficio è di solito possibile dopo due-tre settimane.",
        },
        {
          name: "Il lungo termine",
          text:
            "Vitamina B12, ferro, folati, vitamina D e calcio per tutta la vita, con esami del sangue a tre, sei e dodici mesi e poi ogni anno. Il follow-up continua quando il peso smette di scendere: è allora che compaiono le carenze e il recupero del peso.",
        },
      ],
    },
    risks: {
      heading: "Cosa può andare storto",
      intro:
        "Uno sleeve è un cambiamento permanente di un organo sano. Queste sono le complicanze di cui i pazienti vengono davvero avvisati, e sono la ragione per cui l'intervento si esegue in un ospedale con copertura bariatrica.",
      items: [
        "Deiscenza della linea di sutura in circa l'1–3% dei pazienti, di solito tra il terzo e il decimo giorno; richiede drenaggio, talvolta uno stent, a volte un nuovo intervento",
        "Sanguinamento dalla linea di sutura o dalla milza, che può richiedere trasfusione e, raramente, un reintervento",
        "Stenosi o torsione del tubo, con vomito ripetuto e difficoltà a deglutire, trattate con dilatazione endoscopica",
        "Reflusso acido nuovo o peggiorato — uno dei rilievi più frequenti dopo uno sleeve, e motivo per cui alcuni pazienti vengono indirizzati al bypass",
        "Carenza a lungo termine di B12, ferro, folati, vitamina D e calcio se integratori e controlli vengono trascurati",
      ],
      note:
        "Il recupero del peso accade, soprattutto dal terzo anno in poi, quando le porzioni tornano a crescere e il follow-up si interrompe. La chirurgia è uno strumento, non una cura: compra una finestra in cui ricostruire le abitudini alimentari, e la finestra si chiude se dentro non si ricostruisce nulla.",
    },
    faq: {
      heading: "Domande che i pazienti pongono",
      items: [
        {
          q: "Quanto peso perderò?",
          a:
            "Tipicamente intorno al 25–30% del peso corporeo totale nei primi uno-due anni, anche se la variabilità tra pazienti è ampia e dipende dal peso di partenza, dall'aderenza e dal follow-up. Nessuno può promettere una cifra prima della valutazione.",
        },
        {
          q: "Dovrò prendere integratori per tutta la vita?",
          a:
            "Nella maggior parte dei casi sì: vitamina B12, ferro, folati, vitamina D e calcio, con esami del sangue per adattarli. Lo stomaco rimosso produce fattore intrinseco e acido, quindi l'assorbimento cambia in modo permanente.",
        },
        {
          q: "Si può annullare?",
          a:
            "Lo stomaco non torna alla forma originale. Se uno sleeve fallisce — reflusso grave, scarsa perdita di peso, recupero del peso — il passo successivo abituale è la conversione a bypass gastrico, che è un intervento più importante.",
        },
        {
          q: "E una gravidanza dopo?",
          a:
            "La gravidanza è possibile, ma molti chirurghi consigliano di attendere 12–18 mesi perché peso e stato nutrizionale si stabilizzino. Integratori e controlli proseguono durante la gravidanza.",
        },
      ],
    },
    ctaBand: {
      heading: "Invia altezza, peso e storia clinica",
      text:
        "Un chirurgo bariatrico li esamina e un coordinatore ti risponde indicando se una valutazione è sensata, quali esami servirebbero prima e un preventivo scritto, senza obbligo di prenotare.",
      button: "Parla con un coordinatore",
    },
    disclaimer:
      "Informazioni generali, non consigli medici. L'idoneità si può valutare solo dopo una valutazione completa da parte di un chirurgo bariatrico, comprese la revisione psicologica e quella nutrizionale; risultati e rischi variano da paziente a paziente.",
    seoTitle: "Sleeve gastrico a Istanbul | Platinya",
    seoDesc:
      "Sleeve gastrico a Istanbul: stomaco rimodellato in un tubo, due-tre notti in clinica e follow-up nutrizionale a lungo termine. Indicazioni e rischi.",
  },

  "/stomach-balloon": {
    title: "Palloncino gastrico a Istanbul",
    eyebrow: "Chirurgia per la perdita di peso",
    lead:
      "Un palloncino viene posizionato all'interno dello stomaco e riempito, così c'è meno spazio per il cibo e il senso di sazietà arriva prima. Resta in sede da sei a dodici mesi e poi viene rimosso. È un aiuto temporaneo, non un intervento e non una cura dell'obesità.",
    cta: "Prenota una valutazione gratuita",
    heroAlt: "Consultazione per palloncino gastrico presso Platinya Clinic",
    stats: [
      { value: "20–30 min", label: "Posizionamento" },
      { value: "6–12 mesi", label: "Permanenza in sede" },
      { value: "3–7 giorni", label: "Per stabilizzarsi" },
    ],
    candidate: {
      heading: "Chi è un buon candidato",
      intro:
        "Un palloncino è adatto a chi deve perdere una quantità significativa di peso prima di qualcos'altro — un intervento articolare, un trattamento per la fertilità, la riparazione di un'ernia — o a chi ha bisogno di un periodo iniziale definito per cambiare le abitudini alimentari sotto supervisione. Non è adatto a chi cerca una procedura che faccia il lavoro da sola.",
      items: [
        "Un BMI all'incirca tra 27 e 35, senza condizioni che rendano l'endoscopia non sicura",
        "Un peso che non ha risposto a dieta e attività fisica supervisionate, o un motivo medico per perdere peso rapidamente",
        "Nessun precedente intervento gastrico o esofageo, e nessuna grande ernia iatale o ulcera attiva",
        "Disponibilità a seguire un programma dietistico nei mesi di permanenza e dopo la rimozione",
      ],
      note:
        "Il palloncino non è un trattamento per un BMI superiore a 40 da solo e non viene proposto a chi è in gravidanza, programma una gravidanza entro l'anno o ha un disturbo alimentare attivo. Lo screening comprende anamnesi, esami del sangue e, secondo il dispositivo, una gastroscopia.",
    },
    techniques: {
      heading: "I due modi di posizionare un palloncino",
      intro:
        "Entrambi occupano spazio nello stomaco. Ciò che cambia è come arrivano, quanto possono restare e se serve la sedazione.",
      items: [
        {
          name: "Palloncino endoscopico",
          text:
            "Posizionato dalla bocca con un gastroscopio in sedazione, poi riempito con soluzione fisiologica e un colorante, così che un'eventuale perdita sia visibile. Richiede circa 20–30 minuti. Viene rimosso allo stesso modo al termine del periodo previsto, di solito sei o dodici mesi.",
        },
        {
          name: "Palloncino ingeribile",
          text:
            "Una capsula viene deglutita con acqua, controllata con una radiografia e poi riempita con gas attraverso un sottile catetere. Nessuna sedazione e nessuna endoscopia. Resta circa quattro mesi ed è progettato per essere eliminato naturalmente, anche se a volte è necessaria la rimozione endoscopica.",
        },
        {
          name: "Il programma che lo accompagna",
          text:
            "Nessuno dei due dispositivi funziona senza la dieta che lo accompagna: un piano guidato da un dietista, obiettivi proteici, follow-up comportamentale e una transizione strutturata verso l'alimentazione normale nelle settimane precedenti la rimozione. È questa la parte che determina il risultato.",
        },
      ],
    },
    journey: {
      heading: "Dallo screening alla vita dopo la rimozione",
      steps: [
        {
          name: "Screening",
          text:
            "Anamnesi, revisione dei farmaci, esami del sangue e una gastroscopia se il dispositivo la richiede. Qualsiasi ulcera, ernia o reflusso viene trattata prima del posizionamento, non dopo.",
        },
        {
          name: "Il giorno del posizionamento",
          text:
            "Di solito in day hospital. Sedazione per la versione endoscopica; solo acqua e una capsula per quella ingeribile. Resti in osservazione per alcune ore, ricevi antiemetici e torni a casa lo stesso giorno.",
        },
        {
          name: "La prima settimana",
          text:
            "Nausea, crampi e vomito sono frequenti e attesi: lo stomaco protesta per qualcosa che ha dentro. Antiemetici, piccole quantità di liquidi e, se serve, liquidi per via endovenosa. La maggior parte delle persone si stabilizza in tre-sette giorni.",
        },
        {
          name: "I mesi di permanenza",
          text:
            "Liquidi, poi cibi morbidi, poi consistenze normali in due-tre settimane. Le porzioni sono più piccole perché lo stomaco è più piccolo. Controlli dietistici ogni quattro-sei settimane; esami del sangue se l'apporto resta basso.",
        },
        {
          name: "Rimozione e dopo",
          text:
            "La rimozione richiede 20–30 minuti. L'appetito di solito torna in giorni o settimane e, senza le abitudini costruite durante il programma, il peso ritorna. Un piano di mantenimento — follow-up dietistico, attività fisica, talvolta farmaci — si concorda prima che il palloncino venga rimosso.",
        },
      ],
    },
    risks: {
      heading: "Cosa può andare storto",
      intro:
        "Un palloncino è meno invasivo della chirurgia, non privo di rischi. Queste sono le complicanze di cui si parla prima del posizionamento.",
      items: [
        "Nausea, vomito e crampi addominali nella prima settimana, talvolta così intensi da richiedere liquidi per via endovenosa",
        "Reflusso, pirosi e irritazione dell'esofago o della mucosa gastrica durante la permanenza del palloncino",
        "Sgonfiamento o migrazione del palloncino, che può ostruire l'intestino — non frequente, ma un'emergenza quando accade",
        "Ulcerazione, erosione o, molto raramente, perforazione della parete gastrica, che richiede chirurgia",
        "Recupero del peso dopo la rimozione, frequente quando il programma dietetico non viene proseguito",
      ],
      note:
        "Un palloncino compra tempo e uno stomaco più piccolo, nulla di più. Non cambia il modo in cui il corpo gestisce il cibo, non tratta le ragioni per cui mangiare era difficile, e il peso perso è di solito modesto: tipicamente tra il 5% e il 15% del peso corporeo durante la permanenza.",
    },
    faq: {
      heading: "Domande che i pazienti pongono",
      items: [
        {
          q: "Quanto peso perderò?",
          a:
            "Comunemente nell'ordine del 5–15% del peso corporeo nel periodo di permanenza, con ampia variabilità. È meno di uno sleeve o di un bypass, e una parte viene spesso ripresa dopo la rimozione.",
        },
        {
          q: "È doloroso?",
          a:
            "Il posizionamento non è doloroso: la gola viene anestetizzata e si usa la sedazione. I primi tre-sette giorni sono di solito fastidiosi, con nausea, crampi e vomito. Gli antiemetici vengono prescritti prima della dimissione.",
        },
        {
          q: "Posso mangiare normalmente con il palloncino?",
          a:
            "Consistenze normali sì; porzioni normali no. Mangiare troppo in fretta o troppo provoca dolore e vomito, e le bevande gassate e i cibi molto fibrosi sono poco tollerati da alcuni pazienti.",
        },
        {
          q: "Cosa accade quando viene rimosso?",
          a:
            "Lo stomaco torna alle dimensioni precedenti in pochi giorni. L'appetito spesso ritorna rapidamente. Se il peso resti via dipende da ciò che è stato costruito in quei mesi, ed è per questo che il programma dietistico conta più del dispositivo.",
        },
      ],
    },
    ctaBand: {
      heading: "Scopri se un palloncino è il punto di partenza giusto",
      text:
        "Invia altezza, peso e storia clinica. Un medico bariatrico li esamina e un coordinatore ti risponde indicando se un palloncino o una valutazione chirurgica siano adatti al tuo caso e cosa comportano.",
      button: "Parla con un coordinatore",
    },
    disclaimer:
      "Informazioni generali, non consigli medici. L'idoneità dipende da una valutazione di un medico bariatrico, comprese l'anamnesi e, dove indicato, la gastroscopia; i risultati variano da paziente a paziente.",
    seoTitle: "Palloncino gastrico a Istanbul | Platinya",
    seoDesc:
      "Palloncino gastrico a Istanbul: endoscopico o ingeribile, resta 6-12 mesi e si rimuove. Un aiuto temporaneo con programma dietetico, non una cura.",
  },

  "/filler": {
    title: "Filler di acido ialuronico a Istanbul",
    eyebrow: "Medicina estetica",
    lead:
      "L'acido ialuronico è uno zucchero che la pelle già contiene. Reticolato in un gel e posizionato sotto la pelle, ripristina il volume perduto e ammorbidisce le pieghe che si sono formate. È una procedura medica con rischi reali, non un trattamento di bellezza.",
    cta: "Prenota una valutazione gratuita",
    heroAlt: "Consultazione per filler presso Platinya Clinic",
    stats: [
      { value: "30–60 min", label: "Durata dell'appuntamento" },
      { value: "6–18 mesi", label: "Durata del risultato" },
      { value: "24–72 h", label: "Gonfiore ed ematomi" },
    ],
    candidate: {
      heading: "A chi è adatto e a chi no",
      intro:
        "Il candidato giusto ha un problema specifico e descrivibile — una piega, uno svuotamento, un contorno perduto — non il desiderio di somigliare a qualcun altro. Il volume si ripristina dove è venuto meno, non si aggiunge ovunque sia possibile.",
      items: [
        "Volume perduto su guance, tempie o terzo medio del viso, o pieghe che restano quando il viso è a riposo",
        "Una linea mandibolare o un mento che hanno perso definizione, o labbra assottigliate con l'età e non prive di volume da sempre",
        "Buone condizioni generali di salute, nessuna infezione attiva o infiammazione cutanea nella zona da trattare",
        "Aspettative realistiche: il filler ripristina volume, non solleva un viso caduto né elimina la lassità cutanea",
      ],
      note:
        "Il filler non viene eseguito in gravidanza o durante l'allattamento, su acne attiva, herpes labiale o infezione, né in caso di allergia nota all'acido ialuronico o alla lidocaina. Gli anticoagulanti e alcuni integratori aumentano il rischio di ematomi e vengono rivalutati prima, non ignorati. A chi chiede un filler permanente si risponde di no e si propone un parere chirurgico.",
    },
    techniques: {
      heading: "Prodotto, piano di inserimento e quantità",
      intro:
        "Il risultato dipende molto più da dove viene posizionato il prodotto e da quanto se ne usa che dal marchio sulla confezione.",
      items: [
        {
          name: "Scegliere il gel",
          text:
            "I filler di acido ialuronico differiscono per quanto sono reticolati e per la consistenza del gel. Gel più morbidi per labbra e rughe sottili, più consistenti per i piani profondi sopra l'osso. La maggior parte contiene lidocaina, che rende l'iniezione più confortevole.",
        },
        {
          name: "Ago o cannula, e quale piano",
          text:
            "L'ago è preciso per labbra e pieghe sottili; una cannula smussa riduce gli ematomi e permette di deporre il prodotto in un unico passaggio. Un posizionamento profondo sopra l'osso sostiene; uno superficiale rifinisce. Il piano è una decisione clinica, non una preferenza.",
        },
        {
          name: "Dosi prudenti, per tappe",
          text:
            "Trattare meno del necessario e rivalutare a due-quattro settimane è più sicuro che correggere in un'unica seduta. Il tessuto troppo riempito si distende, e la pelle distesa non si ritrae: è così che i visi finiscono per sembrare riempiti invece che riposati.",
        },
      ],
    },
    journey: {
      heading: "Dalla consulenza alla rivalutazione",
      steps: [
        {
          name: "Consulenza",
          text:
            "Il viso viene valutato a riposo e in movimento, si scattano fotografie e si rivede l'anamnesi: gravidanza, malattie autoimmuni, herpes labiale, filler precedenti e dove sono stati posizionati. Un filler permanente precedente cambia completamente il piano.",
        },
        {
          name: "Progetto e consenso",
          text:
            "Zone, prodotto, volume e costo si concordano per iscritto prima di aprire qualsiasi confezione. I rischi vengono spiegati, compresa l'occlusione vascolare, e ti viene detto che l'ialuronidasi — l'enzima che dissolve il prodotto — è disponibile in clinica.",
        },
        {
          name: "L'appuntamento",
          text:
            "Da trenta a sessanta minuti, crema anestetica compresa. Le iniezioni richiedono dieci-venti di quei minuti. Labbra e solco sotto l'occhio sono le zone più sensibili; la maggior parte delle persone descrive una pressione più che un dolore.",
        },
        {
          name: "Le prime 72 ore",
          text:
            "Il gonfiore raggiunge il picco a 24–48 ore e gli ematomi possono richiedere una settimana per sbiadire. Evita calore, sauna, esercizio intenso e alcol per 24–48 ore, e cure dentarie per due settimane se sono state trattate le labbra o la zona nasogeniena. La prima notte dormire leggermente sollevati aiuta.",
        },
        {
          name: "Rivalutazione a due-quattro settimane",
          text:
            "Il risultato si giudica quando il gonfiore è sparito. A volte è opportuno un piccolo ritocco; non si corregge nella prima settimana, quando tutto appare più grande di come sarà. Il trattamento successivo si programma in base a quanto dura davvero il prodotto nel tuo tessuto.",
        },
      ],
    },
    risks: {
      heading: "Cosa può andare storto",
      intro:
        "Sono iniezioni mediche in una zona riccamente vascolarizzata. I rischi gravi sono poco frequenti, ma sono la ragione per cui questo trattamento appartiene a una clinica con un medico presente e un antidoto disponibile.",
      items: [
        "Ematomi, gonfiore e dolorabilità per qualche giorno — frequenti, e più probabili con gli anticoagulanti",
        "Occlusione vascolare — il prodotto blocca un'arteria, causando dolore, pallore e, se non trattata, necrosi cutanea e cicatrici; l'ialuronidasi va somministrata entro poche ore",
        "Perdita della vista da embolizzazione nel circolo retinico — molto rara, in gran parte irreversibile, e ragione per cui alcune zone vengono trattate solo da iniettori esperti",
        "Noduli, granulomi o reazioni infiammatorie tardive a mesi di distanza, talvolta scatenate da una malattia o da una vaccinazione",
        "Asimmetria, migrazione del prodotto o un aspetto troppo riempito che non si può annullare del tutto in una sola seduta",
      ],
      note:
        "L'acido ialuronico si può dissolvere con l'ialuronidasi, ed è per questo che è l'unico filler sensato sul viso. I prodotti permanenti e le sostanze non dichiarate non si possono rimuovere, e sono la ragione più comune per cui un paziente viene rifiutato o indirizzato alla chirurgia.",
    },
    faq: {
      heading: "Domande che i pazienti pongono",
      items: [
        {
          q: "Fa male?",
          a:
            "Si applica una crema anestetica per venti-trenta minuti e la maggior parte dei prodotti contiene lidocaina. Labbra e zona sotto l'occhio sono le più sensibili: si tratta di fastidio più che di dolore, e dura pochi secondi per iniezione.",
        },
        {
          q: "Si può annullare?",
          a:
            "Sì, se è acido ialuronico: l'ialuronidasi lo dissolve in un giorno o due. Non è una ragione per riempire troppo, ma è il motivo per cui il prodotto conta più del prezzo.",
        },
        {
          q: "Si vedrà che l'ho fatto?",
          a:
            "No, se il prodotto è posizionato nel piano giusto e la quantità resta prudente. Un risultato evidente di solito significa troppo prodotto, troppo in superficie, in una zona che aveva bisogno di sostegno più che di volume.",
        },
        {
          q: "Ogni quanto servirà un ritocco?",
          a:
            "Ogni sei-diciotto mesi secondo il prodotto, la zona e la rapidità con cui lo degradi. Labbra e zone molto mobili tendono a richiedere un ritocco prima del sostegno profondo delle guance.",
        },
      ],
    },
    ctaBand: {
      heading: "Chiedi a un medico di cosa ha davvero bisogno il tuo viso",
      text:
        "Invia due fotografie — frontale e di tre quarti, a riposo — e un medico le esamina. Ricevi una risposta onesta su se il filler sia il trattamento giusto, e su cos'altro potrebbe esserlo.",
      button: "Invia le tue foto",
    },
    disclaimer:
      "Informazioni generali, non consigli medici. I filler sono dispositivi medici su prescrizione e sono indicati solo dopo una consulenza con un professionista qualificato; l'idoneità varia da paziente a paziente.",
    seoTitle: "Filler di acido ialuronico a Istanbul | Platinya",
    seoDesc:
      "Filler di acido ialuronico a Istanbul: volume ripristinato e pieghe ammorbidite, con durata di 6-18 mesi. Rischi vascolari e reversibilità spiegati.",
  },

  "/face-botox": {
    title: "Tossina botulinica per il viso a Istanbul",
    eyebrow: "Medicina estetica",
    lead:
      "La tossina botulinica blocca il segnale che ordina a un muscolo di contrarsi. Iniettata in dosi piccole e misurate nella parte superiore del viso, attenua le rughe che il movimento ha scavato, e l'effetto svanisce: è questo il punto.",
    cta: "Prenota una valutazione gratuita",
    heroAlt: "Consultazione per tossina botulinica presso Platinya Clinic",
    stats: [
      { value: "15–30 min", label: "Durata dell'appuntamento" },
      { value: "10–14 giorni", label: "Effetto completo" },
      { value: "3–4 mesi", label: "Durata" },
    ],
    candidate: {
      heading: "A chi è adatto e a chi no",
      intro:
        "La tossina tratta le rughe prodotte dal movimento. Non fa nulla per il volume perduto o per la pelle che è caduta: quelli richiedono filler o chirurgia, e proporre la tossina in quei casi è come i pazienti finiscono delusi.",
      items: [
        "Rughe glabellari tra le sopracciglia, rughe orizzontali della fronte e zampe di gallina visibili in movimento",
        "Rughe ancora dinamiche — compaiono quando aggrotti le sopracciglia o sorridi — e non già incise a riposo",
        "Buone condizioni generali di salute, senza motivi per evitare un farmaco su prescrizione",
        "Aspettative realistiche: il viso appare meno teso, non più giovane, e l'effetto è temporaneo",
      ],
      note:
        "La tossina botulinica non viene somministrata in gravidanza o durante l'allattamento, né a chi ha una malattia neuromuscolare come miastenia grave, sindrome di Lambert-Eaton o malattia del motoneurone, o un'allergia nota al prodotto o all'albumina che lo veicola. Un'infezione attiva nella sede di iniezione e una ptosi palpebrale preesistente sono motivi relativi per attendere o trattare diversamente.",
    },
    techniques: {
      heading: "Dove si inietta e quanto",
      intro:
        "Le dosi sono in unità specifiche per ogni marca e non sono confrontabili tra loro. Ciò che conta è lo schema di iniezione, scelto da come si muovono davvero i tuoi muscoli.",
      items: [
        {
          name: "Glabella — le rughe del corruccio",
          text:
            "Di solito la prima zona trattata, in genere 20–30 unità su cinque punti di iniezione. È la zona con il risultato più affidabile e anche quella in cui una dose mal posizionata può causare la caduta della palpebra.",
        },
        {
          name: "Fronte",
          text:
            "In genere 10–20 unità, posizionate per attenuare le rughe orizzontali senza appiattire del tutto la fronte. Trattare la fronte da sola, senza la glabella, spesso fa sollevare la parte interna del sopracciglio in modo innaturale: le zone si progettano insieme.",
        },
        {
          name: "Zampe di gallina",
          text:
            "In genere 6–12 unità per lato, su tre punti attorno all'angolo esterno dell'occhio. È una zona superficiale e vicina al bordo orbitario, quindi gli ematomi sono frequenti e la dose resta bassa per evitare uno sguardo pesante e chiuso.",
        },
      ],
    },
    journey: {
      heading: "Dalla consulenza alla rivalutazione",
      steps: [
        {
          name: "Consulenza",
          text:
            "Il viso viene osservato a riposo e in movimento — corruccio, sollevamento delle sopracciglia, strizzata degli occhi — perché la dose si sceglie sul muscolo, non sulla ruga. Si rivedono anamnesi, farmaci e trattamenti precedenti con la tossina, e si scattano fotografie.",
        },
        {
          name: "L'appuntamento",
          text:
            "Da quindici a trenta minuti. Non serve anestesia; se lo desideri si usa il ghiaccio. Ago sottile, diverse micro-iniezioni, pochi secondi ciascuna. Puoi tornare al lavoro immediatamente.",
        },
        {
          name: "Le prime 24 ore",
          text:
            "Niente sfregamenti o massaggi sulla zona per quattro ore, non sdraiarsi per quattro ore e niente palestra, sauna o alcol per 24 ore. Un leggero mal di testa e piccoli ematomi sono frequenti; il trucco si può applicare lo stesso giorno se la pelle non è lesa.",
        },
        {
          name: "Dal terzo al quattordicesimo giorno",
          text:
            "L'effetto inizia intorno al secondo-terzo giorno e raggiunge il massimo a 10–14 giorni. Giudicare il risultato prima porta a ritocchi inutili: la rivalutazione si fissa al quattordicesimo giorno.",
        },
        {
          name: "La rivalutazione, poi il mantenimento",
          text:
            "A due settimane si controlla lo schema e, se serve, si esegue una piccola correzione. L'effetto dura tre-quattro mesi, a volte meno in chi la metabolizza rapidamente. Un trattamento ogni tre-quattro mesi mantiene il risultato stabile senza aumentare le dosi.",
        },
      ],
    },
    risks: {
      heading: "Cosa può andare storto",
      intro:
        "È un farmaco su prescrizione, e i rischi sono quelli della tossina stessa più che dell'ago.",
      items: [
        "Ematomi, gonfiore e un leggero mal di testa per un giorno o due, più frequenti attorno agli occhi",
        "Caduta della palpebra o del sopracciglio (ptosi) in circa l'1–2% dei trattamenti della glabella — temporanea, si risolve in due-quattro settimane, talvolta aiutata da colliri",
        "Asimmetria, o un sopracciglio più alto da un lato, di solito correggibile alla rivalutazione delle due settimane",
        "Un'espressione innaturale — fronte appiattita o sopracciglio a punta — per una dose o uno schema non adatti ai muscoli",
        "Secchezza oculare, gonfiore palpebrale o difficoltà a sollevare il sopracciglio e, raramente, debolezza generalizzata o una reazione simil-influenzale",
      ],
      note:
        "Informa il medico di ogni farmaco e integratore, dei trattamenti precedenti con la tossina e di quanto sono durati, e di eventuali casi di malattia neuromuscolare in famiglia. La tossina non tratta la pelle caduta né il volume perduto, e non sostituisce un parere chirurgico quando è quello di cui il viso ha bisogno.",
    },
    faq: {
      heading: "Domande che i pazienti pongono",
      items: [
        {
          q: "Il viso sembrerà congelato?",
          a:
            "Non a una dose misurata. L'obiettivo è attenuare il movimento, non fermarlo. Un aspetto congelato deriva dal trattare ogni zona a dose piena — ed è reversibile, che è il vantaggio rispetto alla chirurgia.",
        },
        {
          q: "Quando vedrò il risultato?",
          a:
            "Il movimento inizia ad attenuarsi intorno al secondo-terzo giorno e l'effetto completo è presente a 10–14 giorni. Ciò che sembra irregolare prima di allora è di solito ancora in evoluzione.",
        },
        {
          q: "Cosa accade se smetto?",
          a:
            "Il muscolo torna alla sua attività precedente in qualche mese e le rughe tornano dove erano. Non c'è un peggioramento di rimbalzo, anche se rughe represse per anni possono apparire più marcate all'inizio.",
        },
        {
          q: "Si può associare al filler?",
          a:
            "Spesso sì: la tossina per il movimento, il filler per il volume, e vengono frequentemente eseguiti nella stessa visita. Ordine e tempi li decide il medico, perché entrambi cambiano il modo in cui si valuta il viso.",
        },
      ],
    },
    ctaBand: {
      heading: "Chiedi a un medico se la tossina è la risposta giusta",
      text:
        "Invia due fotografie — una con il corruccio e una a riposo — e un medico le esamina. Ricevi una risposta onesta su se le rughe siano muscolari e su cos'altro servirebbe se non lo sono.",
      button: "Invia le tue foto",
    },
    disclaimer:
      "Informazioni generali, non consigli medici. La tossina botulinica è un farmaco su prescrizione, somministrato solo dopo una consulenza con un professionista qualificato; idoneità e dose variano da paziente a paziente.",
    seoTitle: "Tossina botulinica viso a Istanbul | Platinya",
    seoDesc:
      "Tossina botulinica per il viso a Istanbul: glabella, fronte e zampe di gallina. Effetto completo in 10-14 giorni e durata di 3-4 mesi. Rischi e limiti.",
  },
};
